import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AdminDto = {
  __typename?: 'AdminDto';
  avatar?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  phoneExt?: Maybe<Scalars['Int']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

export type AdminType = {
  __typename?: 'AdminType';
  avatar: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CalculationRequestInput = {
  birthDate: Scalars['String']['input'];
  coverages: Array<Scalars['String']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

export type CalculationResponseDto = {
  __typename?: 'CalculationResponseDto';
  actionLabel?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  calculatorConfig?: Maybe<CalculatorProductConfigDto>;
  calculatorFilterProperties?: Maybe<Array<CalculatorFilterPropertyDto>>;
  code: Scalars['String']['output'];
  coverages?: Maybe<Array<CalculatorCoverageWithPriceDto>>;
  detailsLink?: Maybe<Scalars['String']['output']>;
  diffPrice?: Maybe<Scalars['Float']['output']>;
  fixedCoverages?: Maybe<Array<CalculatorFixedCoverageDto>>;
  label?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  premiumEligibleAgeMax?: Maybe<Scalars['Int']['output']>;
  premiumEligibleAgeMin?: Maybe<Scalars['Int']['output']>;
  priceWithoutDiscounts: Scalars['Float']['output'];
  prices: ProductCalculationPricesDto;
  visual?: Maybe<CalculatorProductVisualDto>;
};

export type CalculatorCoverageWithPriceDto = {
  __typename?: 'CalculatorCoverageWithPriceDto';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editOnWeb?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CalculatorFilterPropertyDto = {
  __typename?: 'CalculatorFilterPropertyDto';
  key: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type CalculatorFixedCoverageDto = {
  __typename?: 'CalculatorFixedCoverageDto';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type CalculatorProductConfigDto = {
  __typename?: 'CalculatorProductConfigDto';
  calculationCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  visual?: Maybe<CalculatorProductVisualDto>;
  webservice: Scalars['Boolean']['output'];
};

export type CalculatorProductVisualDto = {
  __typename?: 'CalculatorProductVisualDto';
  description: Scalars['String']['output'];
  discount: Array<Scalars['String']['output']>;
  highlight: Scalars['Boolean']['output'];
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type CallMeInput = {
  number: Scalars['String']['input'];
  product: Scalars['String']['input'];
  soId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutHealthOfferDataInput = {
  contractor: HealthOfferDataContractorInput;
  delivery: HealthOfferDataDeliveryInput;
  insuredPerson: HealthOfferDataInsuredPersonInput;
  offerId: Scalars['String']['input'];
};

export type CheckoutHealthOfferDto = {
  __typename?: 'CheckoutHealthOfferDto';
  _id: Scalars['String']['output'];
  acceptedEmailDocumentationDeliveryAt?: Maybe<Scalars['String']['output']>;
  additional?: Maybe<HealthOfferBranchDto>;
  allianzGDPRAcceptedAt?: Maybe<Scalars['String']['output']>;
  annotations?: Maybe<Array<Scalars['String']['output']>>;
  brandId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  funnel?: Maybe<HealthOfferFunnelDto>;
  iddTermsAcceptedAt?: Maybe<Scalars['String']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  offerLink?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  soId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  supplementary?: Maybe<HealthOfferBranchDto>;
  termsAcceptedAt?: Maybe<Scalars['String']['output']>;
  total?: Maybe<HealthOfferTotalDto>;
};

export type ConfirmRenewalSoDataInput = {
  additionalInsuranceInfo?: InputMaybe<SoHealthAdditionalInfoInput>;
  phoneNumber: Scalars['String']['input'];
};

export type ConsentInput = {
  consent?: InputMaybe<Array<HealthConsentInput>>;
  offerId: Scalars['String']['input'];
};

export type ContractorInput = {
  contractor?: InputMaybe<ContractorPartInput>;
  delivery?: InputMaybe<DeliveryInput>;
  insuredPerson?: InputMaybe<InsuredPersonInput>;
};

export type ContractorPartInput = {
  asEntity?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oib?: InputMaybe<Scalars['String']['input']>;
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOfferInput = {
  coverages: Array<Scalars['String']['input']>;
  productCode: Scalars['String']['input'];
};

export type CreateSoInput = {
  additionalInsuranceInfo?: InputMaybe<SoHealthAdditionalInfoInput>;
  cancellationDate?: InputMaybe<Scalars['String']['input']>;
  crossSell?: InputMaybe<CrossSellInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  diffPrice?: InputMaybe<Scalars['Float']['input']>;
  drugList?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasBList?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  partnerSource?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  productTypeCode?: InputMaybe<Scalars['String']['input']>;
  soId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  visitorIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CrossSellInput = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  productTypeCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CrossSellSource>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** Source of the cross-sell */
export enum CrossSellSource {
  GeneralSo = 'GENERAL_SO',
  KompareOffer = 'KOMPARE_OFFER',
  SellingOpportunity = 'SELLING_OPPORTUNITY'
}

export type DeliveryEntityEditableValue = {
  __typename?: 'DeliveryEntityEditableValue';
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DeliveryInput = {
  asEntity?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  isRegularDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['Float']['input']>;
};

export type FunnelStepType = {
  __typename?: 'FunnelStepType';
  code: Scalars['String']['output'];
  openedAt: Scalars['String']['output'];
};

export type FunnelType = {
  __typename?: 'FunnelType';
  latestStep: Scalars['String']['output'];
  steps: Array<FunnelStepType>;
};

export type GenderEditableValue = {
  __typename?: 'GenderEditableValue';
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GeneralTransferDetailsInput = {
  installments: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type GeneralTransferInfo = {
  __typename?: 'GeneralTransferInfo';
  customerAddress: Scalars['String']['output'];
  customerCity: Scalars['String']['output'];
  customerCountry: Scalars['String']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerFirstName: Scalars['String']['output'];
  customerLastName: Scalars['String']['output'];
  customerOib: Scalars['String']['output'];
  customerPhone?: Maybe<Scalars['String']['output']>;
  customerZipCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  model: Scalars['String']['output'];
  numberOfInstallments?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  recipientAccountNumber: Scalars['String']['output'];
  recipientAddress: Scalars['String']['output'];
  recipientCity: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  recipientZipCode: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  referenceNumberType: Scalars['String']['output'];
  referencePrefix: Scalars['String']['output'];
  referenceSuffix: Scalars['String']['output'];
};

export type GetOfferDto = {
  __typename?: 'GetOfferDto';
  _id: Scalars['String']['output'];
  acceptedEmailDocumentationDeliveryAt?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  funnel?: Maybe<OfferFunnelType>;
  iddTermsAcceptedAt?: Maybe<Scalars['String']['output']>;
  paymentErrors?: Maybe<Array<OfferPaymentErrorType>>;
  product?: Maybe<OfferProductType>;
  productTypeSpecific?: Maybe<OfferProductTypeSpecificType>;
  soId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  termsAcceptedAt?: Maybe<Scalars['String']['output']>;
};

export type GetSoDto = {
  __typename?: 'GetSoDto';
  _id: Scalars['String']['output'];
  admin?: Maybe<AdminType>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  funnel?: Maybe<FunnelType>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  productTypeId: ProductTypeGraphQl;
  productTypeSpecific?: Maybe<ProductTypeSpecificType>;
  soNumber: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GetWspayPaymentDataInput = {
  installment: Scalars['Int']['input'];
  paymentOption: Scalars['String']['input'];
  paymentType: Scalars['String']['input'];
};

export type HealthConsentInput = {
  CarGiveAway?: InputMaybe<Scalars['Boolean']['input']>;
  allianzGDPR?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  fourteenDayCancellationPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  generalTOSConsent?: InputMaybe<Scalars['Boolean']['input']>;
  healthEmailDocumentationConsent?: InputMaybe<Scalars['Boolean']['input']>;
  healthNeedConsent?: InputMaybe<Scalars['Boolean']['input']>;
  healthValidDataConsent?: InputMaybe<Scalars['Boolean']['input']>;
  kompareHelp?: InputMaybe<Scalars['Boolean']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  newsletterSpecialOffers?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HealthOfferBranchDto = {
  __typename?: 'HealthOfferBranchDto';
  actionLabel?: Maybe<Scalars['String']['output']>;
  additionalCoverages?: Maybe<Array<HealthOfferIncludedItemDto>>;
  baseProductPrice?: Maybe<Scalars['Float']['output']>;
  brandCode?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  coverages?: Maybe<Array<HealthOfferCoverageDto>>;
  discounts?: Maybe<Array<HealthOfferDiscountDto>>;
  fixedCoverages?: Maybe<Array<HealthOfferCoverageDto>>;
  includedInPrice?: Maybe<Array<HealthOfferIncludedItemDto>>;
  label?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  numberOfInstallments?: Maybe<Scalars['Int']['output']>;
  paymentSlipInfo?: Maybe<HealthOfferPaymentSlipInfoDto>;
  priceChangeModifier?: Maybe<HealthOfferPriceChangeModifierDto>;
  total?: Maybe<HealthOfferTotalDto>;
  visual?: Maybe<HealthOfferVisualDto>;
  voucherPriceChangeModifier?: Maybe<HealthOfferVoucherPriceChangeModifierDto>;
  voucherPriceModifier?: Maybe<HealthOfferVoucherPriceModifierDto>;
};

export type HealthOfferCoverageDto = {
  __typename?: 'HealthOfferCoverageDto';
  description?: Maybe<Scalars['String']['output']>;
  gratis?: Maybe<HealthOfferGratisDto>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<HealthOfferCoverageOptionDto>>;
  price?: Maybe<Scalars['Float']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferCoverageOptionDto = {
  __typename?: 'HealthOfferCoverageOptionDto';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferData = {
  __typename?: 'HealthOfferData';
  collectContractorPhone?: Maybe<Scalars['Boolean']['output']>;
  contractor?: Maybe<HealthOfferDataContractor>;
  delivery?: Maybe<HealthOfferDataDelivery>;
  hasPolicy?: Maybe<Scalars['Boolean']['output']>;
  insuredPerson?: Maybe<HealthOfferDataInsuredPerson>;
  karenca?: Maybe<Scalars['Boolean']['output']>;
  newPolicyStartDate?: Maybe<Scalars['String']['output']>;
  newPolicyStartDateNote?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  termsDocuments?: Maybe<Array<HealthOfferTermsDocument>>;
  termsLink?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferDataContractor = {
  __typename?: 'HealthOfferDataContractor';
  company?: Maybe<HealthOfferDataContractorCompany>;
  isSamePerson?: Maybe<Scalars['Boolean']['output']>;
  person?: Maybe<HealthOfferDataContractorPerson>;
  personType?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferDataContractorCompany = {
  __typename?: 'HealthOfferDataContractorCompany';
  city?: Maybe<StringEditableValue>;
  cityKompareId?: Maybe<StringEditableValue>;
  companyName?: Maybe<StringEditableValue>;
  houseNumber?: Maybe<StringEditableValue>;
  oib?: Maybe<StringEditableValue>;
  partnerContactEmail?: Maybe<StringEditableValue>;
  phoneNumber?: Maybe<StringEditableValue>;
  street?: Maybe<StringEditableValue>;
  streetAndHouseNumber?: Maybe<StringEditableValue>;
  streetKompareId?: Maybe<StringEditableValue>;
  zipCode?: Maybe<IntEditableValue>;
};

export type HealthOfferDataContractorCompanyInput = {
  city: Scalars['String']['input'];
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  oib: Scalars['String']['input'];
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  streetAndHouseNumber: Scalars['String']['input'];
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['Int']['input'];
};

export type HealthOfferDataContractorInput = {
  company?: InputMaybe<HealthOfferDataContractorCompanyInput>;
  isSamePerson: Scalars['Boolean']['input'];
  person?: InputMaybe<HealthOfferDataContractorPersonInput>;
  personType: Scalars['String']['input'];
};

export type HealthOfferDataContractorPerson = {
  __typename?: 'HealthOfferDataContractorPerson';
  birthDate?: Maybe<StringEditableValue>;
  city?: Maybe<StringEditableValue>;
  cityKompareId?: Maybe<StringEditableValue>;
  firstName?: Maybe<StringEditableValue>;
  gender?: Maybe<GenderEditableValue>;
  houseNumber?: Maybe<StringEditableValue>;
  lastName?: Maybe<StringEditableValue>;
  oib?: Maybe<StringEditableValue>;
  partnerContactEmail?: Maybe<StringEditableValue>;
  phoneNumber?: Maybe<StringEditableValue>;
  street?: Maybe<StringEditableValue>;
  streetAndHouseNumber?: Maybe<StringEditableValue>;
  streetKompareId?: Maybe<StringEditableValue>;
  zipCode?: Maybe<IntEditableValue>;
};

export type HealthOfferDataContractorPersonInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oib?: InputMaybe<Scalars['String']['input']>;
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['Int']['input']>;
};

export type HealthOfferDataDelivery = {
  __typename?: 'HealthOfferDataDelivery';
  asEntity?: Maybe<DeliveryEntityEditableValue>;
  city?: Maybe<StringEditableValue>;
  cityKompareId?: Maybe<StringEditableValue>;
  houseNumber?: Maybe<StringEditableValue>;
  name?: Maybe<StringEditableValue>;
  street?: Maybe<StringEditableValue>;
  streetAndHouseNumber?: Maybe<StringEditableValue>;
  streetKompareId?: Maybe<StringEditableValue>;
  zipCode?: Maybe<IntEditableValue>;
};

export type HealthOfferDataDeliveryInput = {
  asEntity: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['Int']['input']>;
};

export type HealthOfferDataInsuredPerson = {
  __typename?: 'HealthOfferDataInsuredPerson';
  birthDate?: Maybe<StringEditableValue>;
  city?: Maybe<StringEditableValue>;
  cityKompareId?: Maybe<StringEditableValue>;
  firstName?: Maybe<StringEditableValue>;
  gender?: Maybe<GenderEditableValue>;
  houseNumber?: Maybe<StringEditableValue>;
  insuranceNumber?: Maybe<StringEditableValue>;
  lastName?: Maybe<StringEditableValue>;
  oib?: Maybe<StringEditableValue>;
  partnerContactEmail?: Maybe<StringEditableValue>;
  personalIdIssuer?: Maybe<StringEditableValue>;
  personalIdNumber?: Maybe<StringEditableValue>;
  phoneNumber?: Maybe<StringEditableValue>;
  street?: Maybe<StringEditableValue>;
  streetAndHouseNumber?: Maybe<StringEditableValue>;
  streetKompareId?: Maybe<StringEditableValue>;
  zipCode?: Maybe<IntEditableValue>;
};

export type HealthOfferDataInsuredPersonInput = {
  city: Scalars['String']['input'];
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  houseNumber: Scalars['String']['input'];
  insuranceNumber?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  oib: Scalars['String']['input'];
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  personalIdIssuer?: InputMaybe<Scalars['String']['input']>;
  personalIdNumber?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['Int']['input'];
};

export type HealthOfferDiscountDto = {
  __typename?: 'HealthOfferDiscountDto';
  tooltip?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferFunnelDto = {
  __typename?: 'HealthOfferFunnelDto';
  latestStep?: Maybe<HealthOfferFunnelStepDto>;
  steps?: Maybe<Array<HealthOfferFunnelStepDto>>;
};

export type HealthOfferFunnelStepDto = {
  __typename?: 'HealthOfferFunnelStepDto';
  code: Scalars['String']['output'];
  openedAt: Scalars['String']['output'];
};

export type HealthOfferGratisDto = {
  __typename?: 'HealthOfferGratisDto';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthOfferIncludedItemDto = {
  __typename?: 'HealthOfferIncludedItemDto';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** Single installment line for a payment type */
export type HealthOfferPaymentInstallment = {
  __typename?: 'HealthOfferPaymentInstallment';
  amount: Scalars['Float']['output'];
  installment: Scalars['Int']['output'];
  paymentTypeDiscount: Scalars['Float']['output'];
};

/** Grouped option (credit card, transfer, keksPay, …) */
export type HealthOfferPaymentOption = {
  __typename?: 'HealthOfferPaymentOption';
  paymentOption: Scalars['String']['output'];
  paymentSlipInfo?: Maybe<HealthOfferPaymentSlipInfo>;
  paymentTypes: Array<HealthOfferPaymentType>;
};

/** Payment slip metadata shown on transfer-method rows */
export type HealthOfferPaymentSlipInfo = {
  __typename?: 'HealthOfferPaymentSlipInfo';
  amount?: Maybe<Scalars['Float']['output']>;
  numOfInstallments?: Maybe<Scalars['Int']['output']>;
};

export type HealthOfferPaymentSlipInfoDto = {
  __typename?: 'HealthOfferPaymentSlipInfoDto';
  amount?: Maybe<Scalars['Float']['output']>;
  numOfInstallments?: Maybe<Scalars['Int']['output']>;
};

/** Card / transfer method under a payment option */
export type HealthOfferPaymentType = {
  __typename?: 'HealthOfferPaymentType';
  installments: Array<HealthOfferPaymentInstallment>;
  paymentType: Scalars['String']['output'];
  paymentTypeLabel: Scalars['String']['output'];
};

export type HealthOfferPriceChangeModifierDto = {
  __typename?: 'HealthOfferPriceChangeModifierDto';
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferTermsDocument = {
  __typename?: 'HealthOfferTermsDocument';
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type HealthOfferTotalDto = {
  __typename?: 'HealthOfferTotalDto';
  creditCard?: Maybe<Scalars['Float']['output']>;
  creditCardWithInstallments?: Maybe<Scalars['Float']['output']>;
  generalTransfer?: Maybe<Scalars['Float']['output']>;
  generalTransferWithInstallments?: Maybe<Scalars['Float']['output']>;
};

export type HealthOfferVisualDto = {
  __typename?: 'HealthOfferVisualDto';
  description?: Maybe<Scalars['String']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferVoucherPriceChangeModifierDto = {
  __typename?: 'HealthOfferVoucherPriceChangeModifierDto';
  amount?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferVoucherPriceModifierDto = {
  __typename?: 'HealthOfferVoucherPriceModifierDto';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type HealthQuestionnaireAnswerItemInput = {
  followUpAnswers?: InputMaybe<Array<HealthQuestionnaireFollowUpAnswerInput>>;
  questionCode: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type HealthQuestionnaireFollowUpAnswerInput = {
  fieldCode: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type InsuredPersonInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  insuranceNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oib?: InputMaybe<Scalars['String']['input']>;
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<Scalars['String']['input']>;
  personalIdIssuer?: InputMaybe<Scalars['String']['input']>;
  personalIdNumber?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['Int']['input']>;
};

export type IntEditableValue = {
  __typename?: 'IntEditableValue';
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptTerms?: Maybe<Scalars['String']['output']>;
  callMe: Scalars['String']['output'];
  checkAndApplyVoucherCode?: Maybe<CheckoutHealthOfferDto>;
  checkoutPaymentErrors?: Maybe<Scalars['String']['output']>;
  confirmRenewalSoData: Scalars['String']['output'];
  createHealthOffer?: Maybe<Scalars['String']['output']>;
  createSo: Scalars['String']['output'];
  paymentAttempt?: Maybe<Scalars['String']['output']>;
  removeVoucherCode?: Maybe<CheckoutHealthOfferDto>;
  saveAndSubmitHealthQuestionnaireForAdmin: SubmitHealthQuestionnaireResponseDto;
  saveConsent: Scalars['Boolean']['output'];
  saveHealthQuestionnaireAnswers: Scalars['String']['output'];
  savePolicyCancellation: Scalars['Boolean']['output'];
  selectOffer: Scalars['String']['output'];
  sendGeneralTransferDetails?: Maybe<Scalars['String']['output']>;
  sendOffersToEmail: Scalars['Boolean']['output'];
  sendPolicyCancelationEmail: Scalars['Boolean']['output'];
  sendTermsAndConditionsToEmail?: Maybe<Scalars['String']['output']>;
  setContractor: Scalars['String']['output'];
  setInsuranceNumber: Scalars['Boolean']['output'];
  setWsPayCallbackResponse?: Maybe<Scalars['String']['output']>;
  setWsPayResponse?: Maybe<Scalars['String']['output']>;
  submitHealthQuestionnaire: SubmitHealthQuestionnaireResponseDto;
  updateCheckoutHealthOfferData: Scalars['Boolean']['output'];
};


export type MutationAcceptTermsArgs = {
  id: Scalars['String']['input'];
  input: TermsInput;
};


export type MutationCallMeArgs = {
  input: CallMeInput;
};


export type MutationCheckAndApplyVoucherCodeArgs = {
  offerId: Scalars['String']['input'];
  voucherCode: Scalars['String']['input'];
};


export type MutationCheckoutPaymentErrorsArgs = {
  id: Scalars['String']['input'];
  input: PaymentErrorInput;
};


export type MutationConfirmRenewalSoDataArgs = {
  id: Scalars['String']['input'];
  input: ConfirmRenewalSoDataInput;
};


export type MutationCreateHealthOfferArgs = {
  id: Scalars['String']['input'];
  input: CreateOfferInput;
};


export type MutationCreateSoArgs = {
  input: CreateSoInput;
};


export type MutationPaymentAttemptArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveVoucherCodeArgs = {
  offerId: Scalars['String']['input'];
};


export type MutationSaveAndSubmitHealthQuestionnaireForAdminArgs = {
  adminId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  input: SaveHealthQuestionnaireAnswersInput;
};


export type MutationSaveConsentArgs = {
  params: ConsentInput;
};


export type MutationSaveHealthQuestionnaireAnswersArgs = {
  id: Scalars['String']['input'];
  input: SaveHealthQuestionnaireAnswersInput;
};


export type MutationSavePolicyCancellationArgs = {
  cancellationDate?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSelectOfferArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendGeneralTransferDetailsArgs = {
  id: Scalars['String']['input'];
  input: GeneralTransferDetailsInput;
};


export type MutationSendOffersToEmailArgs = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  soId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendPolicyCancelationEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  soId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendTermsAndConditionsToEmailArgs = {
  id: Scalars['String']['input'];
};


export type MutationSetContractorArgs = {
  id: Scalars['String']['input'];
  input: ContractorInput;
  offerId: Scalars['String']['input'];
};


export type MutationSetInsuranceNumberArgs = {
  id: Scalars['String']['input'];
  insuranceNumber: Scalars['String']['input'];
};


export type MutationSetWsPayCallbackResponseArgs = {
  id: Scalars['String']['input'];
  input: WsPayResponseInput;
};


export type MutationSetWsPayResponseArgs = {
  id: Scalars['String']['input'];
  input: WsPayResponseInput;
};


export type MutationSubmitHealthQuestionnaireArgs = {
  flow: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateCheckoutHealthOfferDataArgs = {
  params: CheckoutHealthOfferDataInput;
};

export type OfferAdditionalCalculatedType = {
  __typename?: 'OfferAdditionalCalculatedType';
  baseProductPrice?: Maybe<Scalars['Float']['output']>;
  coverages?: Maybe<OfferCalculatedPricesCoveragesType>;
  total?: Maybe<OfferTotalPriceType>;
};

export type OfferAdditionalType = {
  __typename?: 'OfferAdditionalType';
  code?: Maybe<Scalars['String']['output']>;
  coverages?: Maybe<Array<OfferCoverageEntryType>>;
  gratis?: Maybe<OfferGratisType>;
  priceChangeModifier?: Maybe<OfferPriceModifierType>;
  voucherPriceChangeModifier?: Maybe<OfferVoucherPriceChangeModifierType>;
  voucherPriceModifier?: Maybe<OfferVoucherPriceModifierType>;
};

export type OfferBrandType = {
  __typename?: 'OfferBrandType';
  code: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type OfferCalculatedPricesCoveragesType = {
  __typename?: 'OfferCalculatedPricesCoveragesType';
  additionalDailyHospitalAllowance?: Maybe<OfferCoveragePriceType>;
};

export type OfferCalculatedPricesType = {
  __typename?: 'OfferCalculatedPricesType';
  additional?: Maybe<OfferAdditionalCalculatedType>;
  supplementary?: Maybe<OfferSupplementaryCalculatedType>;
  total?: Maybe<OfferTotalPriceType>;
};

export type OfferContractorType = {
  __typename?: 'OfferContractorType';
  asEntity?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityKompareId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  isSamePerson?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  oib?: Maybe<Scalars['String']['output']>;
  partnerContactEmail?: Maybe<Scalars['String']['output']>;
  personType?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetAndHouseNumber?: Maybe<Scalars['String']['output']>;
  streetKompareId?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['Int']['output']>;
};

export type OfferCoverageEntryType = {
  __typename?: 'OfferCoverageEntryType';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  gratis?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
};

export type OfferCoveragePriceType = {
  __typename?: 'OfferCoveragePriceType';
  amount?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
};

export type OfferDeliveryType = {
  __typename?: 'OfferDeliveryType';
  asEntity?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityKompareId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  isRegularDelivery?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  personType?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetAndHouseNumber?: Maybe<Scalars['String']['output']>;
  streetKompareId?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['Int']['output']>;
};

export type OfferFunnelStepType = {
  __typename?: 'OfferFunnelStepType';
  code: Scalars['String']['output'];
  openedAt: Scalars['String']['output'];
};

export type OfferFunnelType = {
  __typename?: 'OfferFunnelType';
  latestStep?: Maybe<OfferFunnelStepType>;
  steps: Array<OfferFunnelStepType>;
};

export type OfferGratisType = {
  __typename?: 'OfferGratisType';
  additionalSecondOpinion?: Maybe<Scalars['String']['output']>;
};

export type OfferHealthQuestionnaireAnswerType = {
  __typename?: 'OfferHealthQuestionnaireAnswerType';
  followUpAnswers?: Maybe<Array<OfferHealthQuestionnaireFollowUpAnswerType>>;
  questionCode: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OfferHealthQuestionnaireFollowUpAnswerType = {
  __typename?: 'OfferHealthQuestionnaireFollowUpAnswerType';
  fieldCode: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OfferHealthQuestionnaireMessageType = {
  __typename?: 'OfferHealthQuestionnaireMessageType';
  message: Scalars['String']['output'];
  ruleCode: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OfferHealthQuestionnaireType = {
  __typename?: 'OfferHealthQuestionnaireType';
  answers: Array<OfferHealthQuestionnaireAnswerType>;
  brandCode: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<OfferHealthQuestionnaireMessageType>>;
  rejected?: Maybe<Scalars['Boolean']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
};

export type OfferInsuredPersonDetailsType = {
  __typename?: 'OfferInsuredPersonDetailsType';
  asEntity?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityKompareId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  importantNote?: Maybe<Scalars['String']['output']>;
  insuranceNumber?: Maybe<Scalars['String']['output']>;
  karenca?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  newPolicyStartDate?: Maybe<Scalars['String']['output']>;
  oib?: Maybe<Scalars['String']['output']>;
  partnerContactEmail?: Maybe<Scalars['String']['output']>;
  personType?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetAndHouseNumber?: Maybe<Scalars['String']['output']>;
  streetKompareId?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['Int']['output']>;
};

export type OfferPaymentErrorType = {
  __typename?: 'OfferPaymentErrorType';
  createdAt?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type OfferPaymentOptions = {
  __typename?: 'OfferPaymentOptions';
  offer?: Maybe<CheckoutHealthOfferDto>;
  paymentOptions: Array<HealthOfferPaymentOption>;
};

export type OfferPriceModifierType = {
  __typename?: 'OfferPriceModifierType';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OfferProductType = {
  __typename?: 'OfferProductType';
  annotations: Array<Scalars['String']['output']>;
  brand: OfferBrandType;
  code: Scalars['String']['output'];
  fixedCoverages?: Maybe<Array<OfferCoverageEntryType>>;
  name: Scalars['String']['output'];
  premiumEligibleAgeMax: Scalars['Int']['output'];
  premiumEligibleAgeMin: Scalars['Int']['output'];
};

export type OfferProductTypeSpecificType = {
  __typename?: 'OfferProductTypeSpecificType';
  additional?: Maybe<OfferAdditionalType>;
  calculatedPrices?: Maybe<OfferCalculatedPricesType>;
  contractor?: Maybe<OfferContractorType>;
  delivery?: Maybe<OfferDeliveryType>;
  healthQuestionnaire?: Maybe<OfferHealthQuestionnaireType>;
  insuredPerson?: Maybe<OfferInsuredPersonDetailsType>;
  paidAt?: Maybe<Scalars['String']['output']>;
  shoppingCartId: Scalars['Int']['output'];
  supplementary?: Maybe<OfferSupplementaryType>;
};

export type OfferSupplementaryCalculatedType = {
  __typename?: 'OfferSupplementaryCalculatedType';
  baseProductPrice?: Maybe<Scalars['Float']['output']>;
  coverages?: Maybe<OfferCalculatedPricesCoveragesType>;
  total?: Maybe<OfferTotalPriceType>;
};

export type OfferSupplementaryType = {
  __typename?: 'OfferSupplementaryType';
  actionLabel?: Maybe<Scalars['String']['output']>;
  brandCode?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  coverages?: Maybe<Array<OfferCoverageEntryType>>;
  label?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  numberOfInstallments?: Maybe<Scalars['Float']['output']>;
  priceChangeModifier?: Maybe<OfferPriceModifierType>;
  voucherPriceChangeModifier?: Maybe<OfferVoucherPriceChangeModifierType>;
  voucherPriceModifier?: Maybe<OfferVoucherPriceModifierType>;
};

export type OfferTermsAndConditionsDocumentDto = {
  __typename?: 'OfferTermsAndConditionsDocumentDto';
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type OfferTermsAndConditionsGetDto = {
  __typename?: 'OfferTermsAndConditionsGetDto';
  brandCode: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  documents: Array<OfferTermsAndConditionsDocumentDto>;
  logoUrl: Scalars['String']['output'];
};

export type OfferTotalPriceType = {
  __typename?: 'OfferTotalPriceType';
  creditCard?: Maybe<Scalars['Float']['output']>;
  creditCardWithInstallments?: Maybe<Scalars['Float']['output']>;
  generalTransfer?: Maybe<Scalars['Float']['output']>;
  generalTransferWithInstallments?: Maybe<Scalars['Float']['output']>;
};

export type OfferVoucherPriceChangeModifierType = {
  __typename?: 'OfferVoucherPriceChangeModifierType';
  amount?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OfferVoucherPriceModifierType = {
  __typename?: 'OfferVoucherPriceModifierType';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type OverflowVoucherStatus = {
  __typename?: 'OverflowVoucherStatus';
  active: Scalars['Boolean']['output'];
  voucherCode: Scalars['String']['output'];
  voucherDescription: Scalars['String']['output'];
  voucherValue: Scalars['Float']['output'];
};

export type PaymentErrorInput = {
  errorCodes: Array<Scalars['String']['input']>;
};

export type PersonalVoucherStatus = {
  __typename?: 'PersonalVoucherStatus';
  campaignName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  generatedUniqueCodes?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Type of physical examination */
export enum PhysicalExaminationEnum {
  Basic = 'Basic',
  Extended = 'Extended',
  NotSpecified = 'NotSpecified'
}

export type ProductCalculationPricesDto = {
  __typename?: 'ProductCalculationPricesDto';
  creditCard: Scalars['Float']['output'];
  creditCardWithInstallments: Scalars['Float']['output'];
  generalTransfer: Scalars['Float']['output'];
  generalTransferWithInstallments: Scalars['Float']['output'];
};

export type ProductTypeGraphQl = {
  __typename?: 'ProductTypeGraphQL';
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProductTypeSpecificType = {
  __typename?: 'ProductTypeSpecificType';
  additionalInsuranceInfo?: Maybe<SoHealthAdditionalInfoType>;
  insuredPerson?: Maybe<SoHealthInsuredPersonType>;
  renewalOf?: Maybe<SoRenewalOfType>;
};

export type Query = {
  __typename?: 'Query';
  checkoutHealthOffer?: Maybe<CheckoutHealthOfferDto>;
  checkoutHealthOfferData?: Maybe<HealthOfferData>;
  checkoutHealthOfferGeneralTransferDetails?: Maybe<GeneralTransferInfo>;
  checkoutHealthOfferPaymentOptions?: Maybe<OfferPaymentOptions>;
  checkoutHealthOffers?: Maybe<Array<CheckoutHealthOfferDto>>;
  getAdmin?: Maybe<AdminDto>;
  getCalculations: Array<CalculationResponseDto>;
  getGeneralTransferPaymentDetails?: Maybe<GeneralTransferInfo>;
  getOffer?: Maybe<GetOfferDto>;
  getOfferForAgent?: Maybe<GetOfferDto>;
  getOfferForPrint?: Maybe<GetOfferDto>;
  getOfferPaymentOptions?: Maybe<OfferPaymentOptions>;
  getOffersBySoId?: Maybe<Array<GetOfferDto>>;
  getSo?: Maybe<GetSoDto>;
  getTermsAndConditions?: Maybe<OfferTermsAndConditionsGetDto>;
  getTermsAndConditionsById?: Maybe<TermsAndConditionsDto>;
  getTermsAndConditionsFromFiles?: Maybe<OfferTermsAndConditionsGetDto>;
  getTermsOffer?: Maybe<GetOfferDto>;
  getWSPayPaymentData?: Maybe<WspayPaymentData>;
  hasActiveAdditionalHealthPolicy?: Maybe<Scalars['Boolean']['output']>;
  healthQuestionnaireQuestions: Array<QuestionDto>;
  overflowVoucherStatus?: Maybe<OverflowVoucherStatus>;
  personalVoucherStatus?: Maybe<PersonalVoucherStatus>;
  soPartner?: Maybe<SoPartnerDto>;
};


export type QueryCheckoutHealthOfferArgs = {
  id: Scalars['String']['input'];
};


export type QueryCheckoutHealthOfferDataArgs = {
  id: Scalars['String']['input'];
};


export type QueryCheckoutHealthOfferGeneralTransferDetailsArgs = {
  installments: Scalars['Int']['input'];
  offerId: Scalars['String']['input'];
};


export type QueryCheckoutHealthOfferPaymentOptionsArgs = {
  offerId: Scalars['String']['input'];
};


export type QueryCheckoutHealthOffersArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetAdminArgs = {
  isEncrypted?: InputMaybe<Scalars['Boolean']['input']>;
  referenceId: Scalars['String']['input'];
  referenceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCalculationsArgs = {
  input: CalculationRequestInput;
  soId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGeneralTransferPaymentDetailsArgs = {
  id: Scalars['String']['input'];
  input: GeneralTransferDetailsInput;
};


export type QueryGetOfferArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOfferForAgentArgs = {
  adminId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryGetOfferForPrintArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOfferPaymentOptionsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOffersBySoIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetSoArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTermsAndConditionsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTermsAndConditionsByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTermsAndConditionsFromFilesArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTermsOfferArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetWsPayPaymentDataArgs = {
  id: Scalars['String']['input'];
  input: GetWspayPaymentDataInput;
};


export type QueryHasActiveAdditionalHealthPolicyArgs = {
  id: Scalars['String']['input'];
};


export type QueryHealthQuestionnaireQuestionsArgs = {
  brandCode: Scalars['String']['input'];
  dontExclude?: InputMaybe<Scalars['Boolean']['input']>;
  productCode: Scalars['String']['input'];
};


export type QueryPersonalVoucherStatusArgs = {
  soId: Scalars['String']['input'];
};


export type QuerySoPartnerArgs = {
  soId: Scalars['String']['input'];
};

export type QuestionDto = {
  __typename?: 'QuestionDto';
  code: Scalars['String']['output'];
  columns?: Maybe<Array<QuestionnaireQuestionColumnDto>>;
  description?: Maybe<Scalars['String']['output']>;
  extraInfo?: Maybe<Scalars['String']['output']>;
  followUp?: Maybe<QuestionnaireFollowUpDto>;
  options?: Maybe<Array<QuestionnaireQuestionOptionDto>>;
  questions?: Maybe<Array<QuestionDto>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  rows?: Maybe<Array<QuestionnaireQuestionRowDto>>;
  selectionMode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireFollowUpConditionDto = {
  __typename?: 'QuestionnaireFollowUpConditionDto';
  countWhere?: Maybe<QuestionnaireFollowUpCountWhereDto>;
  operator?: Maybe<Scalars['String']['output']>;
  parentQuestionCode: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  when: Scalars['String']['output'];
};

export type QuestionnaireFollowUpCountWhereDto = {
  __typename?: 'QuestionnaireFollowUpCountWhereDto';
  answer?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestionnaireFollowUpDto = {
  __typename?: 'QuestionnaireFollowUpDto';
  code: Scalars['String']['output'];
  fields?: Maybe<Array<QuestionnaireFollowUpFieldDto>>;
  requireWhen?: Maybe<QuestionnaireFollowUpConditionDto>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  visibility?: Maybe<QuestionnaireFollowUpConditionDto>;
};

export type QuestionnaireFollowUpFieldDto = {
  __typename?: 'QuestionnaireFollowUpFieldDto';
  code: Scalars['String']['output'];
  inputType: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Array<QuestionnaireFollowUpFieldOptionDto>>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestionnaireFollowUpFieldOptionDto = {
  __typename?: 'QuestionnaireFollowUpFieldOptionDto';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type QuestionnaireQuestionColumnDto = {
  __typename?: 'QuestionnaireQuestionColumnDto';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type QuestionnaireQuestionOptionDto = {
  __typename?: 'QuestionnaireQuestionOptionDto';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type QuestionnaireQuestionRowDto = {
  __typename?: 'QuestionnaireQuestionRowDto';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type SaveHealthQuestionnaireAnswersInput = {
  answers: Array<HealthQuestionnaireAnswerItemInput>;
  brandCode: Scalars['String']['input'];
};

export type SoHealthAdditionalInfoInput = {
  diagnostic: Scalars['Boolean']['input'];
  laboratoryExaminations?: InputMaybe<SpecialistExaminationsEnum>;
  mrCt: Scalars['Boolean']['input'];
  perMonthPayment: Scalars['String']['input'];
  physicalExamination?: InputMaybe<PhysicalExaminationEnum>;
  physicalTherapy: Scalars['Boolean']['input'];
  reasonOfPurchase: Scalars['String']['input'];
  smallOperatingCycles: Scalars['Boolean']['input'];
  specialistExaminations: Scalars['Boolean']['input'];
};

export type SoHealthAdditionalInfoType = {
  __typename?: 'SoHealthAdditionalInfoType';
  diagnostic: Scalars['Boolean']['output'];
  laboratoryExaminations?: Maybe<SpecialistExaminationsEnum>;
  mrCt: Scalars['Boolean']['output'];
  perMonthPayment: Scalars['String']['output'];
  physicalExamination?: Maybe<PhysicalExaminationEnum>;
  physicalTherapy: Scalars['Boolean']['output'];
  reasonOfPurchase: Scalars['String']['output'];
  smallOperatingCycles: Scalars['Boolean']['output'];
  specialistExaminations: Scalars['Boolean']['output'];
};

export type SoHealthInsuredPersonType = {
  __typename?: 'SoHealthInsuredPersonType';
  accessAge?: Maybe<Scalars['Float']['output']>;
  asEntity?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityKompareId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  importantNote?: Maybe<Scalars['String']['output']>;
  isRegularDelivery?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  newPolicyStartDate?: Maybe<Scalars['String']['output']>;
  oib?: Maybe<Scalars['String']['output']>;
  oldPolicyNumber?: Maybe<Scalars['String']['output']>;
  partnerContactEmail?: Maybe<Scalars['String']['output']>;
  personType?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetAndHouseNumber?: Maybe<Scalars['String']['output']>;
  streetKompareId?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['Float']['output']>;
};

export type SoPartnerDto = {
  __typename?: 'SoPartnerDto';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SoRenewalOfType = {
  __typename?: 'SoRenewalOfType';
  brandCode?: Maybe<Scalars['String']['output']>;
  newPolicyStartDate?: Maybe<Scalars['String']['output']>;
  offerId: Scalars['String']['output'];
  oldPolicy?: Maybe<SoRenewalOldPolicyType>;
  productCode?: Maybe<Scalars['String']['output']>;
  productTypeCode: Scalars['String']['output'];
  soId: Scalars['String']['output'];
};

export type SoRenewalOldPolicyPersonType = {
  __typename?: 'SoRenewalOldPolicyPersonType';
  birthDate?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  oib?: Maybe<Scalars['String']['output']>;
};

export type SoRenewalOldPolicyType = {
  __typename?: 'SoRenewalOldPolicyType';
  brandCode?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  contractor?: Maybe<SoRenewalOldPolicyPersonType>;
  endDate?: Maybe<Scalars['String']['output']>;
  insuredPerson?: Maybe<SoRenewalOldPolicyPersonType>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

/** Type of specialist/laboratory examinations */
export enum SpecialistExaminationsEnum {
  Basic = 'Basic',
  Extended = 'Extended'
}

export type StringEditableValue = {
  __typename?: 'StringEditableValue';
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SubmitHealthQuestionnaireResponseDto = {
  __typename?: 'SubmitHealthQuestionnaireResponseDto';
  messages: Array<Scalars['String']['output']>;
  needsConfirmation: Scalars['Boolean']['output'];
  rejected: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  offerChanged?: Maybe<GetOfferDto>;
  offersChanged: Scalars['String']['output'];
};


export type SubscriptionOfferChangedArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionOffersChangedArgs = {
  soId: Scalars['String']['input'];
};

export type TermsAndConditionsDto = {
  __typename?: 'TermsAndConditionsDto';
  contentType: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type TermsInput = {
  allianzGDPRAcceptedAt: Scalars['Boolean']['input'];
};

export type WebCalculationCoverage = {
  __typename?: 'WebCalculationCoverage';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editOnWeb?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type WebCalculationPrice = {
  __typename?: 'WebCalculationPrice';
  totalOneTimePayment: Scalars['Float']['output'];
  totalWithInstallments?: Maybe<Scalars['Float']['output']>;
};

/** WSPay callback / redirect payload fields */
export type WsPayResponseInput = {
  wsPayAmount?: InputMaybe<Scalars['String']['input']>;
  wsPayApprovalCode?: InputMaybe<Scalars['String']['input']>;
  wsPayConfirmationSignature?: InputMaybe<Scalars['String']['input']>;
  wsPayCreditCardNumber?: InputMaybe<Scalars['String']['input']>;
  wsPayCustomerFirstName?: InputMaybe<Scalars['String']['input']>;
  wsPayCustomerLastName?: InputMaybe<Scalars['String']['input']>;
  wsPayDateTime?: InputMaybe<Scalars['String']['input']>;
  wsPayOrderId?: InputMaybe<Scalars['String']['input']>;
  wsPayPartner?: InputMaybe<Scalars['String']['input']>;
  wsPayPaymentPlan?: InputMaybe<Scalars['String']['input']>;
  wsPayPaymentType?: InputMaybe<Scalars['String']['input']>;
  wsPaySTAN?: InputMaybe<Scalars['String']['input']>;
  wsPayShoppingCartId?: InputMaybe<Scalars['String']['input']>;
  wsPaySuccess?: InputMaybe<Scalars['String']['input']>;
};

/** WSPay payment form / redirect parameters */
export type WspayPaymentData = {
  __typename?: 'WspayPaymentData';
  CancelURL: Scalars['String']['output'];
  CustomerAddress?: Maybe<Scalars['String']['output']>;
  CustomerCity?: Maybe<Scalars['String']['output']>;
  CustomerCountry?: Maybe<Scalars['String']['output']>;
  CustomerEmail?: Maybe<Scalars['String']['output']>;
  CustomerFirstName?: Maybe<Scalars['String']['output']>;
  CustomerLastName?: Maybe<Scalars['String']['output']>;
  CustomerPhone?: Maybe<Scalars['String']['output']>;
  CustomerZIP?: Maybe<Scalars['String']['output']>;
  Iframe?: Maybe<Scalars['String']['output']>;
  IframeResponseTarget?: Maybe<Scalars['String']['output']>;
  PaymentMethod?: Maybe<Scalars['String']['output']>;
  PaymentPlan?: Maybe<Scalars['String']['output']>;
  ReturnErrorURL: Scalars['String']['output'];
  ReturnURL: Scalars['String']['output'];
  ShopID: Scalars['String']['output'];
  ShoppingCartID: Scalars['String']['output'];
  Signature: Scalars['String']['output'];
  TotalAmount: Scalars['String']['output'];
  Version: Scalars['String']['output'];
};

export type GetOfferDtoDataFragment = { __typename?: 'GetOfferDto', _id: string, soId: string, status: string, productTypeSpecific?: { __typename?: 'OfferProductTypeSpecificType', shoppingCartId: number, additional?: { __typename?: 'OfferAdditionalType', code?: string | null, coverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null, price?: number | null, gratis?: boolean | null }> | null, priceChangeModifier?: { __typename?: 'OfferPriceModifierType', amount: number, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'OfferVoucherPriceModifierType', amount?: number | null } | null, voucherPriceChangeModifier?: { __typename?: 'OfferVoucherPriceChangeModifierType', amount?: number | null, type?: string | null, description?: string | null, code?: string | null } | null, gratis?: { __typename?: 'OfferGratisType', additionalSecondOpinion?: string | null } | null } | null, calculatedPrices?: { __typename?: 'OfferCalculatedPricesType', additional?: { __typename?: 'OfferAdditionalCalculatedType', baseProductPrice?: number | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, creditCard?: number | null } | null } | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, insuredPerson?: { __typename?: 'OfferInsuredPersonDetailsType', firstName?: string | null, lastName?: string | null, birthDate?: string | null, partnerContactEmail?: string | null, importantNote?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, houseNumber?: string | null, city?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null, oib?: string | null, karenca?: boolean | null, insuranceNumber?: string | null, newPolicyStartDate?: string | null } | null, delivery?: { __typename?: 'OfferDeliveryType', firstName?: string | null, lastName?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, isRegularDelivery?: boolean | null, houseNumber?: string | null, city?: string | null, birthDate?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null } | null, contractor?: { __typename?: 'OfferContractorType', firstName?: string | null, lastName?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, houseNumber?: string | null, city?: string | null, birthDate?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null, partnerContactEmail?: string | null, oib?: string | null, isSamePerson?: boolean | null } | null, healthQuestionnaire?: { __typename?: 'OfferHealthQuestionnaireType', brandCode: string, startedAt?: string | null, completedAt?: string | null, rejected?: boolean | null, isConfirmed?: boolean | null, answers: Array<{ __typename?: 'OfferHealthQuestionnaireAnswerType', questionCode: string, value: string, followUpAnswers?: Array<{ __typename?: 'OfferHealthQuestionnaireFollowUpAnswerType', fieldCode: string, value: string }> | null }>, messages?: Array<{ __typename?: 'OfferHealthQuestionnaireMessageType', message: string, type: string, ruleCode: string }> | null } | null } | null, product?: { __typename?: 'OfferProductType', name: string, code: string, premiumEligibleAgeMin: number, premiumEligibleAgeMax: number, annotations: Array<string>, brand: { __typename?: 'OfferBrandType', code: string, name: string, shortName: string, logoUrl?: string | null }, fixedCoverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null }> | null } | null };

export type HealthQuestionnaireOnOfferFragment = { __typename?: 'OfferProductTypeSpecificType', healthQuestionnaire?: { __typename?: 'OfferHealthQuestionnaireType', brandCode: string, startedAt?: string | null, completedAt?: string | null, rejected?: boolean | null, isConfirmed?: boolean | null, answers: Array<{ __typename?: 'OfferHealthQuestionnaireAnswerType', questionCode: string, value: string, followUpAnswers?: Array<{ __typename?: 'OfferHealthQuestionnaireFollowUpAnswerType', fieldCode: string, value: string }> | null }>, messages?: Array<{ __typename?: 'OfferHealthQuestionnaireMessageType', message: string, type: string, ruleCode: string }> | null } | null };

export type AcceptTermsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: TermsInput;
}>;


export type AcceptTermsMutation = { __typename?: 'Mutation', acceptTerms?: string | null };

export type CallMeAdditionalMutationVariables = Exact<{
  input: CallMeInput;
}>;


export type CallMeAdditionalMutation = { __typename?: 'Mutation', callMe: string };

export type CheckoutPaymentErrorsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: PaymentErrorInput;
}>;


export type CheckoutPaymentErrorsMutation = { __typename?: 'Mutation', checkoutPaymentErrors?: string | null };

export type ConfirmRenewalSoDataMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ConfirmRenewalSoDataInput;
}>;


export type ConfirmRenewalSoDataMutation = { __typename?: 'Mutation', confirmRenewalSoData: string };

export type SetContractorMutationVariables = Exact<{
  id: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  input: ContractorInput;
}>;


export type SetContractorMutation = { __typename?: 'Mutation', setContractor: string };

export type CreateHealthOfferMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: CreateOfferInput;
}>;


export type CreateHealthOfferMutation = { __typename?: 'Mutation', createHealthOffer?: string | null };

export type CreateSoAdditionalMutationVariables = Exact<{
  input: CreateSoInput;
}>;


export type CreateSoAdditionalMutation = { __typename?: 'Mutation', createSo: string };

export type PaymentAttemptMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PaymentAttemptMutation = { __typename?: 'Mutation', paymentAttempt?: string | null };

export type SaveAndSubmitHealthQuestionnaireForAdminMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: SaveHealthQuestionnaireAnswersInput;
  adminId: Scalars['String']['input'];
}>;


export type SaveAndSubmitHealthQuestionnaireForAdminMutation = { __typename?: 'Mutation', saveAndSubmitHealthQuestionnaireForAdmin: { __typename?: 'SubmitHealthQuestionnaireResponseDto', rejected: boolean, messages: Array<string>, needsConfirmation: boolean } };

export type SaveHealthQuestionnaireAnswersMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: SaveHealthQuestionnaireAnswersInput;
}>;


export type SaveHealthQuestionnaireAnswersMutation = { __typename?: 'Mutation', saveHealthQuestionnaireAnswers: string };

export type SelectOfferMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SelectOfferMutation = { __typename?: 'Mutation', selectOffer: string };

export type SendGeneralTransferDetailsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: GeneralTransferDetailsInput;
}>;


export type SendGeneralTransferDetailsMutation = { __typename?: 'Mutation', sendGeneralTransferDetails?: string | null };

export type SendTermsAndConditionsToEmailMutationVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;


export type SendTermsAndConditionsToEmailMutation = { __typename?: 'Mutation', sendTermsAndConditionsToEmail?: string | null };

export type SetWsPayResponseMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: WsPayResponseInput;
}>;


export type SetWsPayResponseMutation = { __typename?: 'Mutation', setWsPayResponse?: string | null };

export type SubmitHealthQuestionnaireMutationVariables = Exact<{
  id: Scalars['String']['input'];
  flow: Scalars['String']['input'];
}>;


export type SubmitHealthQuestionnaireMutation = { __typename?: 'Mutation', submitHealthQuestionnaire: { __typename?: 'SubmitHealthQuestionnaireResponseDto', rejected: boolean, messages: Array<string>, needsConfirmation: boolean } };

export type GetCalculationsQueryVariables = Exact<{
  input: CalculationRequestInput;
}>;


export type GetCalculationsQuery = { __typename?: 'Query', getCalculations: Array<{ __typename?: 'CalculationResponseDto', code: string, label?: string | null, logoUrl?: string | null, priceWithoutDiscounts: number, detailsLink?: string | null, premiumEligibleAgeMin?: number | null, premiumEligibleAgeMax?: number | null, fixedCoverages?: Array<{ __typename?: 'CalculatorFixedCoverageDto', code: string, label: string, tooltip?: string | null, description?: string | null }> | null, coverages?: Array<{ __typename?: 'CalculatorCoverageWithPriceDto', code: string, label?: string | null, tooltip?: string | null, price?: number | null, description?: string | null }> | null, prices: { __typename?: 'ProductCalculationPricesDto', generalTransfer: number, generalTransferWithInstallments: number, creditCard: number, creditCardWithInstallments: number } }> };

export type GetCheckoutDataAdditionalQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCheckoutDataAdditionalQuery = { __typename?: 'Query', getOfferPaymentOptions?: { __typename?: 'OfferPaymentOptions', paymentOptions: Array<{ __typename?: 'HealthOfferPaymentOption', paymentOption: string, paymentTypes: Array<{ __typename?: 'HealthOfferPaymentType', paymentType: string, paymentTypeLabel: string, installments: Array<{ __typename?: 'HealthOfferPaymentInstallment', installment: number, amount: number, paymentTypeDiscount: number }> }> }> } | null, getOffer?: { __typename?: 'GetOfferDto', _id: string, soId: string, status: string, productTypeSpecific?: { __typename?: 'OfferProductTypeSpecificType', shoppingCartId: number, additional?: { __typename?: 'OfferAdditionalType', code?: string | null, coverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null }> | null, priceChangeModifier?: { __typename?: 'OfferPriceModifierType', amount: number, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'OfferVoucherPriceModifierType', amount?: number | null } | null, voucherPriceChangeModifier?: { __typename?: 'OfferVoucherPriceChangeModifierType', amount?: number | null, type?: string | null, description?: string | null, code?: string | null } | null, gratis?: { __typename?: 'OfferGratisType', additionalSecondOpinion?: string | null } | null } | null, calculatedPrices?: { __typename?: 'OfferCalculatedPricesType', additional?: { __typename?: 'OfferAdditionalCalculatedType', baseProductPrice?: number | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, creditCard?: number | null } | null } | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, insuredPerson?: { __typename?: 'OfferInsuredPersonDetailsType', firstName?: string | null, lastName?: string | null, birthDate?: string | null, partnerContactEmail?: string | null, importantNote?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, houseNumber?: string | null, city?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null, oib?: string | null, karenca?: boolean | null, insuranceNumber?: string | null } | null, delivery?: { __typename?: 'OfferDeliveryType', firstName?: string | null, lastName?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, isRegularDelivery?: boolean | null, houseNumber?: string | null, city?: string | null, birthDate?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null } | null, contractor?: { __typename?: 'OfferContractorType', firstName?: string | null, lastName?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, houseNumber?: string | null, city?: string | null, birthDate?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null, partnerContactEmail?: string | null, oib?: string | null, isSamePerson?: boolean | null } | null, healthQuestionnaire?: { __typename?: 'OfferHealthQuestionnaireType', brandCode: string, startedAt?: string | null, completedAt?: string | null, rejected?: boolean | null, isConfirmed?: boolean | null, answers: Array<{ __typename?: 'OfferHealthQuestionnaireAnswerType', questionCode: string, value: string, followUpAnswers?: Array<{ __typename?: 'OfferHealthQuestionnaireFollowUpAnswerType', fieldCode: string, value: string }> | null }>, messages?: Array<{ __typename?: 'OfferHealthQuestionnaireMessageType', message: string, type: string, ruleCode: string }> | null } | null } | null, product?: { __typename?: 'OfferProductType', name: string, code: string, annotations: Array<string>, brand: { __typename?: 'OfferBrandType', code: string, name: string, logoUrl?: string | null }, fixedCoverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null }> | null } | null } | null };

export type GetTermsAndConditionsByIdQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type GetTermsAndConditionsByIdQuery = { __typename?: 'Query', getTermsAndConditionsById?: { __typename?: 'TermsAndConditionsDto', fileName: string, contentType: string, downloadUrl: string } | null };

export type GetGeneralTransferPaymentDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  input: GeneralTransferDetailsInput;
}>;


export type GetGeneralTransferPaymentDetailsQuery = { __typename?: 'Query', getGeneralTransferPaymentDetails?: { __typename?: 'GeneralTransferInfo', price: number, customerFirstName: string, customerLastName: string, customerAddress: string, customerCity: string, customerZipCode: string, customerCountry: string, customerPhone?: string | null, customerEmail?: string | null, customerOib: string, recipientName: string, recipientAddress: string, recipientCity: string, recipientZipCode: string, recipientAccountNumber: string, referenceNumber: string, referenceNumberType: string, referencePrefix: string, referenceSuffix: string, model: string, description: string, numberOfInstallments?: number | null } | null };

export type HealthQuestionnaireQuestionsQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
  dontExclude?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HealthQuestionnaireQuestionsQuery = { __typename?: 'Query', healthQuestionnaireQuestions: Array<{ __typename?: 'QuestionDto', code: string, type?: string | null, required?: boolean | null, title?: string | null, description?: string | null, extraInfo?: string | null, selectionMode?: string | null, options?: Array<{ __typename?: 'QuestionnaireQuestionOptionDto', value: string, label: string }> | null, columns?: Array<{ __typename?: 'QuestionnaireQuestionColumnDto', value: string, label: string }> | null, rows?: Array<{ __typename?: 'QuestionnaireQuestionRowDto', code: string, label: string }> | null, followUp?: { __typename?: 'QuestionnaireFollowUpDto', code: string, type: string, required?: boolean | null, visibility?: { __typename?: 'QuestionnaireFollowUpConditionDto', when: string, parentQuestionCode: string, operator?: string | null, value?: string | null, countWhere?: { __typename?: 'QuestionnaireFollowUpCountWhereDto', answer?: boolean | null } | null } | null, requireWhen?: { __typename?: 'QuestionnaireFollowUpConditionDto', when: string, parentQuestionCode: string, operator?: string | null, value?: string | null, countWhere?: { __typename?: 'QuestionnaireFollowUpCountWhereDto', answer?: boolean | null } | null } | null, fields?: Array<{ __typename?: 'QuestionnaireFollowUpFieldDto', code: string, label: string, required?: boolean | null, inputType: string, options?: Array<{ __typename?: 'QuestionnaireFollowUpFieldOptionDto', label: string, value: string }> | null }> | null } | null, questions?: Array<{ __typename?: 'QuestionDto', code: string, type?: string | null, required?: boolean | null, title?: string | null, description?: string | null, extraInfo?: string | null, options?: Array<{ __typename?: 'QuestionnaireQuestionOptionDto', value: string, label: string }> | null, followUp?: { __typename?: 'QuestionnaireFollowUpDto', code: string, type: string, required?: boolean | null, visibility?: { __typename?: 'QuestionnaireFollowUpConditionDto', when: string, parentQuestionCode: string, operator?: string | null, value?: string | null, countWhere?: { __typename?: 'QuestionnaireFollowUpCountWhereDto', answer?: boolean | null } | null } | null, requireWhen?: { __typename?: 'QuestionnaireFollowUpConditionDto', when: string, parentQuestionCode: string, operator?: string | null, value?: string | null, countWhere?: { __typename?: 'QuestionnaireFollowUpCountWhereDto', answer?: boolean | null } | null } | null, fields?: Array<{ __typename?: 'QuestionnaireFollowUpFieldDto', code: string, label: string, required?: boolean | null, inputType: string, options?: Array<{ __typename?: 'QuestionnaireFollowUpFieldOptionDto', label: string, value: string }> | null }> | null } | null, questions?: Array<{ __typename?: 'QuestionDto', code: string, type?: string | null, required?: boolean | null, title?: string | null, description?: string | null, extraInfo?: string | null, options?: Array<{ __typename?: 'QuestionnaireQuestionOptionDto', value: string, label: string }> | null }> | null }> | null }> };

export type GetOfferQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOfferQuery = { __typename?: 'Query', getOffer?: { __typename?: 'GetOfferDto', _id: string, soId: string, status: string, productTypeSpecific?: { __typename?: 'OfferProductTypeSpecificType', shoppingCartId: number, additional?: { __typename?: 'OfferAdditionalType', code?: string | null, coverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null, price?: number | null, gratis?: boolean | null }> | null, priceChangeModifier?: { __typename?: 'OfferPriceModifierType', amount: number, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'OfferVoucherPriceModifierType', amount?: number | null } | null, voucherPriceChangeModifier?: { __typename?: 'OfferVoucherPriceChangeModifierType', amount?: number | null, type?: string | null, description?: string | null, code?: string | null } | null, gratis?: { __typename?: 'OfferGratisType', additionalSecondOpinion?: string | null } | null } | null, calculatedPrices?: { __typename?: 'OfferCalculatedPricesType', additional?: { __typename?: 'OfferAdditionalCalculatedType', baseProductPrice?: number | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, creditCard?: number | null } | null } | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, insuredPerson?: { __typename?: 'OfferInsuredPersonDetailsType', firstName?: string | null, lastName?: string | null, birthDate?: string | null, partnerContactEmail?: string | null, importantNote?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, houseNumber?: string | null, city?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null, oib?: string | null, karenca?: boolean | null, insuranceNumber?: string | null, newPolicyStartDate?: string | null } | null, delivery?: { __typename?: 'OfferDeliveryType', firstName?: string | null, lastName?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, isRegularDelivery?: boolean | null, houseNumber?: string | null, city?: string | null, birthDate?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null } | null, contractor?: { __typename?: 'OfferContractorType', firstName?: string | null, lastName?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, houseNumber?: string | null, city?: string | null, birthDate?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null, partnerContactEmail?: string | null, oib?: string | null, isSamePerson?: boolean | null } | null, healthQuestionnaire?: { __typename?: 'OfferHealthQuestionnaireType', brandCode: string, startedAt?: string | null, completedAt?: string | null, rejected?: boolean | null, isConfirmed?: boolean | null, answers: Array<{ __typename?: 'OfferHealthQuestionnaireAnswerType', questionCode: string, value: string, followUpAnswers?: Array<{ __typename?: 'OfferHealthQuestionnaireFollowUpAnswerType', fieldCode: string, value: string }> | null }>, messages?: Array<{ __typename?: 'OfferHealthQuestionnaireMessageType', message: string, type: string, ruleCode: string }> | null } | null } | null, product?: { __typename?: 'OfferProductType', name: string, code: string, premiumEligibleAgeMin: number, premiumEligibleAgeMax: number, annotations: Array<string>, brand: { __typename?: 'OfferBrandType', code: string, name: string, shortName: string, logoUrl?: string | null }, fixedCoverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null }> | null } | null } | null };

export type GetOfferForAgentQueryVariables = Exact<{
  id: Scalars['String']['input'];
  adminId: Scalars['String']['input'];
}>;


export type GetOfferForAgentQuery = { __typename?: 'Query', getOfferForAgent?: { __typename?: 'GetOfferDto', _id: string, soId: string, status: string, productTypeSpecific?: { __typename?: 'OfferProductTypeSpecificType', shoppingCartId: number, additional?: { __typename?: 'OfferAdditionalType', code?: string | null, coverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null, price?: number | null, gratis?: boolean | null }> | null, priceChangeModifier?: { __typename?: 'OfferPriceModifierType', amount: number, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'OfferVoucherPriceModifierType', amount?: number | null } | null, voucherPriceChangeModifier?: { __typename?: 'OfferVoucherPriceChangeModifierType', amount?: number | null, type?: string | null, description?: string | null, code?: string | null } | null, gratis?: { __typename?: 'OfferGratisType', additionalSecondOpinion?: string | null } | null } | null, calculatedPrices?: { __typename?: 'OfferCalculatedPricesType', additional?: { __typename?: 'OfferAdditionalCalculatedType', baseProductPrice?: number | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, creditCard?: number | null } | null } | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, insuredPerson?: { __typename?: 'OfferInsuredPersonDetailsType', firstName?: string | null, lastName?: string | null, birthDate?: string | null, partnerContactEmail?: string | null, importantNote?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, houseNumber?: string | null, city?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null, oib?: string | null, karenca?: boolean | null, insuranceNumber?: string | null, newPolicyStartDate?: string | null } | null, delivery?: { __typename?: 'OfferDeliveryType', firstName?: string | null, lastName?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, isRegularDelivery?: boolean | null, houseNumber?: string | null, city?: string | null, birthDate?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null } | null, contractor?: { __typename?: 'OfferContractorType', firstName?: string | null, lastName?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, houseNumber?: string | null, city?: string | null, birthDate?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null, partnerContactEmail?: string | null, oib?: string | null, isSamePerson?: boolean | null } | null, healthQuestionnaire?: { __typename?: 'OfferHealthQuestionnaireType', brandCode: string, startedAt?: string | null, completedAt?: string | null, rejected?: boolean | null, isConfirmed?: boolean | null, answers: Array<{ __typename?: 'OfferHealthQuestionnaireAnswerType', questionCode: string, value: string, followUpAnswers?: Array<{ __typename?: 'OfferHealthQuestionnaireFollowUpAnswerType', fieldCode: string, value: string }> | null }>, messages?: Array<{ __typename?: 'OfferHealthQuestionnaireMessageType', message: string, type: string, ruleCode: string }> | null } | null } | null, product?: { __typename?: 'OfferProductType', name: string, code: string, premiumEligibleAgeMin: number, premiumEligibleAgeMax: number, annotations: Array<string>, brand: { __typename?: 'OfferBrandType', code: string, name: string, shortName: string, logoUrl?: string | null }, fixedCoverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null }> | null } | null } | null };

export type GetOfferForPrintQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOfferForPrintQuery = { __typename?: 'Query', getOfferForPrint?: { __typename?: 'GetOfferDto', _id: string, soId: string, status: string, productTypeSpecific?: { __typename?: 'OfferProductTypeSpecificType', shoppingCartId: number, additional?: { __typename?: 'OfferAdditionalType', code?: string | null, coverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null, price?: number | null, gratis?: boolean | null }> | null, priceChangeModifier?: { __typename?: 'OfferPriceModifierType', amount: number, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'OfferVoucherPriceModifierType', amount?: number | null } | null, voucherPriceChangeModifier?: { __typename?: 'OfferVoucherPriceChangeModifierType', amount?: number | null, type?: string | null, description?: string | null, code?: string | null } | null, gratis?: { __typename?: 'OfferGratisType', additionalSecondOpinion?: string | null } | null } | null, calculatedPrices?: { __typename?: 'OfferCalculatedPricesType', additional?: { __typename?: 'OfferAdditionalCalculatedType', baseProductPrice?: number | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, creditCard?: number | null } | null } | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, insuredPerson?: { __typename?: 'OfferInsuredPersonDetailsType', firstName?: string | null, lastName?: string | null, birthDate?: string | null, partnerContactEmail?: string | null, importantNote?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, houseNumber?: string | null, city?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null, oib?: string | null, karenca?: boolean | null, insuranceNumber?: string | null, newPolicyStartDate?: string | null } | null, delivery?: { __typename?: 'OfferDeliveryType', firstName?: string | null, lastName?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, isRegularDelivery?: boolean | null, houseNumber?: string | null, city?: string | null, birthDate?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null } | null, contractor?: { __typename?: 'OfferContractorType', firstName?: string | null, lastName?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, houseNumber?: string | null, city?: string | null, birthDate?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null, partnerContactEmail?: string | null, oib?: string | null, isSamePerson?: boolean | null } | null, healthQuestionnaire?: { __typename?: 'OfferHealthQuestionnaireType', brandCode: string, startedAt?: string | null, completedAt?: string | null, rejected?: boolean | null, isConfirmed?: boolean | null, answers: Array<{ __typename?: 'OfferHealthQuestionnaireAnswerType', questionCode: string, value: string, followUpAnswers?: Array<{ __typename?: 'OfferHealthQuestionnaireFollowUpAnswerType', fieldCode: string, value: string }> | null }>, messages?: Array<{ __typename?: 'OfferHealthQuestionnaireMessageType', message: string, type: string, ruleCode: string }> | null } | null } | null, product?: { __typename?: 'OfferProductType', name: string, code: string, premiumEligibleAgeMin: number, premiumEligibleAgeMax: number, annotations: Array<string>, brand: { __typename?: 'OfferBrandType', code: string, name: string, shortName: string, logoUrl?: string | null }, fixedCoverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null }> | null } | null } | null };

export type GetOffersBySoIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOffersBySoIdQuery = { __typename?: 'Query', getOffersBySoId?: Array<{ __typename?: 'GetOfferDto', _id: string, status: string, productTypeSpecific?: { __typename?: 'OfferProductTypeSpecificType', shoppingCartId: number, additional?: { __typename?: 'OfferAdditionalType', code?: string | null, coverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null }> | null, priceChangeModifier?: { __typename?: 'OfferPriceModifierType', amount: number, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'OfferVoucherPriceModifierType', amount?: number | null } | null, voucherPriceChangeModifier?: { __typename?: 'OfferVoucherPriceChangeModifierType', amount?: number | null, type?: string | null, description?: string | null, code?: string | null } | null, gratis?: { __typename?: 'OfferGratisType', additionalSecondOpinion?: string | null } | null } | null, calculatedPrices?: { __typename?: 'OfferCalculatedPricesType', additional?: { __typename?: 'OfferAdditionalCalculatedType', baseProductPrice?: number | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, creditCard?: number | null } | null } | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, insuredPerson?: { __typename?: 'OfferInsuredPersonDetailsType', firstName?: string | null, lastName?: string | null, birthDate?: string | null, partnerContactEmail?: string | null, importantNote?: string | null, gender?: string | null } | null, healthQuestionnaire?: { __typename?: 'OfferHealthQuestionnaireType', brandCode: string, startedAt?: string | null, completedAt?: string | null, rejected?: boolean | null, isConfirmed?: boolean | null, answers: Array<{ __typename?: 'OfferHealthQuestionnaireAnswerType', questionCode: string, value: string, followUpAnswers?: Array<{ __typename?: 'OfferHealthQuestionnaireFollowUpAnswerType', fieldCode: string, value: string }> | null }>, messages?: Array<{ __typename?: 'OfferHealthQuestionnaireMessageType', message: string, type: string, ruleCode: string }> | null } | null } | null, product?: { __typename?: 'OfferProductType', name: string, code: string, premiumEligibleAgeMin: number, premiumEligibleAgeMax: number, annotations: Array<string>, brand: { __typename?: 'OfferBrandType', code: string, name: string, logoUrl?: string | null }, fixedCoverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null }> | null } | null }> | null };

export type GetSoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSoQuery = { __typename?: 'Query', getSo?: { __typename?: 'GetSoDto', _id: string, soNumber: number, status: string, source: string, email: string, phoneNumber?: string | null, fullName?: string | null, firstName?: string | null, lastName?: string | null, productTypeId: { __typename?: 'ProductTypeGraphQL', _id: string, code: string, name: string }, funnel?: { __typename?: 'FunnelType', latestStep: string, steps: Array<{ __typename?: 'FunnelStepType', code: string, openedAt: string }> } | null, productTypeSpecific?: { __typename?: 'ProductTypeSpecificType', additionalInsuranceInfo?: { __typename?: 'SoHealthAdditionalInfoType', physicalExamination?: PhysicalExaminationEnum | null, specialistExaminations: boolean, diagnostic: boolean, laboratoryExaminations?: SpecialistExaminationsEnum | null, mrCt: boolean, physicalTherapy: boolean, smallOperatingCycles: boolean, reasonOfPurchase: string, perMonthPayment: string } | null, insuredPerson?: { __typename?: 'SoHealthInsuredPersonType', firstName?: string | null, lastName?: string | null, birthDate?: string | null, city?: string | null, cityKompareId?: string | null, zipCode?: number | null, oib?: string | null, street?: string | null, streetKompareId?: string | null, streetAndHouseNumber?: string | null, houseNumber?: string | null, gender?: string | null, personType?: string | null, partnerContactEmail?: string | null, oldPolicyNumber?: string | null, newPolicyStartDate?: string | null } | null, renewalOf?: { __typename?: 'SoRenewalOfType', productTypeCode: string, productCode?: string | null, newPolicyStartDate?: string | null, oldPolicy?: { __typename?: 'SoRenewalOldPolicyType', brandCode?: string | null, brandName?: string | null, endDate?: string | null } | null } | null } | null, admin?: { __typename?: 'AdminType', name: string, email: string, avatar: string } | null } | null };

export type GetTermsAndConditionsFromFilesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTermsAndConditionsFromFilesQuery = { __typename?: 'Query', getTermsAndConditionsFromFiles?: { __typename?: 'OfferTermsAndConditionsGetDto', brandName: string, brandCode: string, logoUrl: string, documents: Array<{ __typename?: 'OfferTermsAndConditionsDocumentDto', fileId: string, fileName: string }> } | null };

export type GetTermsAndConditionsByOfferQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTermsAndConditionsByOfferQuery = { __typename?: 'Query', getTermsAndConditions?: { __typename?: 'OfferTermsAndConditionsGetDto', brandName: string, brandCode: string, logoUrl: string, documents: Array<{ __typename?: 'OfferTermsAndConditionsDocumentDto', fileId: string, fileName: string }> } | null, getTermsOffer?: { __typename?: 'GetOfferDto', product?: { __typename?: 'OfferProductType', name: string, code: string, brand: { __typename?: 'OfferBrandType', code: string, name: string, logoUrl?: string | null } } | null } | null };

export type GetWsPayPaymentDataQueryVariables = Exact<{
  id: Scalars['String']['input'];
  input: GetWspayPaymentDataInput;
}>;


export type GetWsPayPaymentDataQuery = { __typename?: 'Query', getWSPayPaymentData?: { __typename?: 'WspayPaymentData', ShopID: string, ShoppingCartID: string, TotalAmount: string, Signature: string, ReturnURL: string, CancelURL: string, ReturnErrorURL: string, PaymentPlan?: string | null, CustomerFirstName?: string | null, CustomerLastName?: string | null, CustomerAddress?: string | null, CustomerCity?: string | null, CustomerZIP?: string | null, CustomerCountry?: string | null, CustomerPhone?: string | null, CustomerEmail?: string | null, PaymentMethod?: string | null, Iframe?: string | null, IframeResponseTarget?: string | null, Version: string } | null };

export type OfferChangedSubscriptionVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OfferChangedSubscription = { __typename?: 'Subscription', offerChanged?: { __typename?: 'GetOfferDto', _id: string, soId: string, status: string, productTypeSpecific?: { __typename?: 'OfferProductTypeSpecificType', shoppingCartId: number, additional?: { __typename?: 'OfferAdditionalType', code?: string | null, coverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null, price?: number | null, gratis?: boolean | null }> | null, priceChangeModifier?: { __typename?: 'OfferPriceModifierType', amount: number, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'OfferVoucherPriceModifierType', amount?: number | null } | null, voucherPriceChangeModifier?: { __typename?: 'OfferVoucherPriceChangeModifierType', amount?: number | null, type?: string | null, description?: string | null, code?: string | null } | null, gratis?: { __typename?: 'OfferGratisType', additionalSecondOpinion?: string | null } | null } | null, calculatedPrices?: { __typename?: 'OfferCalculatedPricesType', additional?: { __typename?: 'OfferAdditionalCalculatedType', baseProductPrice?: number | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, creditCard?: number | null } | null } | null, total?: { __typename?: 'OfferTotalPriceType', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, insuredPerson?: { __typename?: 'OfferInsuredPersonDetailsType', firstName?: string | null, lastName?: string | null, birthDate?: string | null, partnerContactEmail?: string | null, importantNote?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, houseNumber?: string | null, city?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null, oib?: string | null, karenca?: boolean | null, insuranceNumber?: string | null, newPolicyStartDate?: string | null } | null, delivery?: { __typename?: 'OfferDeliveryType', firstName?: string | null, lastName?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, isRegularDelivery?: boolean | null, houseNumber?: string | null, city?: string | null, birthDate?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null } | null, contractor?: { __typename?: 'OfferContractorType', firstName?: string | null, lastName?: string | null, gender?: string | null, street?: string | null, streetKompareId?: string | null, houseNumber?: string | null, city?: string | null, birthDate?: string | null, zipCode?: number | null, personType?: string | null, asEntity?: string | null, streetAndHouseNumber?: string | null, cityKompareId?: string | null, partnerContactEmail?: string | null, oib?: string | null, isSamePerson?: boolean | null } | null, healthQuestionnaire?: { __typename?: 'OfferHealthQuestionnaireType', brandCode: string, startedAt?: string | null, completedAt?: string | null, rejected?: boolean | null, isConfirmed?: boolean | null, answers: Array<{ __typename?: 'OfferHealthQuestionnaireAnswerType', questionCode: string, value: string, followUpAnswers?: Array<{ __typename?: 'OfferHealthQuestionnaireFollowUpAnswerType', fieldCode: string, value: string }> | null }>, messages?: Array<{ __typename?: 'OfferHealthQuestionnaireMessageType', message: string, type: string, ruleCode: string }> | null } | null } | null, product?: { __typename?: 'OfferProductType', name: string, code: string, premiumEligibleAgeMin: number, premiumEligibleAgeMax: number, annotations: Array<string>, brand: { __typename?: 'OfferBrandType', code: string, name: string, shortName: string, logoUrl?: string | null }, fixedCoverages?: Array<{ __typename?: 'OfferCoverageEntryType', code: string, label: string, description?: string | null }> | null } | null } | null };

export type OffersChangedSubscriptionVariables = Exact<{
  soId: Scalars['String']['input'];
}>;


export type OffersChangedSubscription = { __typename?: 'Subscription', offersChanged: string };

export const HealthQuestionnaireOnOfferFragmentDoc = gql`
    fragment HealthQuestionnaireOnOffer on OfferProductTypeSpecificType {
  healthQuestionnaire {
    brandCode
    startedAt
    completedAt
    rejected
    isConfirmed
    answers {
      questionCode
      value
      followUpAnswers {
        fieldCode
        value
      }
    }
    messages {
      message
      type
      ruleCode
    }
  }
}
    `;
export const GetOfferDtoDataFragmentDoc = gql`
    fragment GetOfferDtoData on GetOfferDto {
  _id
  soId
  status
  productTypeSpecific {
    shoppingCartId
    ...HealthQuestionnaireOnOffer
    additional {
      code
      coverages {
        code
        label
        description
        price
        gratis
      }
      priceChangeModifier {
        amount
        type
        description
      }
      voucherPriceModifier {
        amount
      }
      voucherPriceChangeModifier {
        amount
        type
        description
        code
      }
      gratis {
        additionalSecondOpinion
      }
    }
    calculatedPrices {
      additional {
        baseProductPrice
        total {
          generalTransfer
          creditCard
        }
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
    }
    insuredPerson {
      firstName
      lastName
      birthDate
      partnerContactEmail
      importantNote
      gender
      street
      streetKompareId
      houseNumber
      city
      zipCode
      personType
      asEntity
      streetAndHouseNumber
      cityKompareId
      oib
      karenca
      insuranceNumber
      newPolicyStartDate
    }
    delivery {
      firstName
      lastName
      gender
      street
      streetKompareId
      isRegularDelivery
      houseNumber
      city
      birthDate
      zipCode
      personType
      asEntity
      streetAndHouseNumber
      cityKompareId
    }
    contractor {
      firstName
      lastName
      gender
      street
      streetKompareId
      houseNumber
      city
      birthDate
      zipCode
      personType
      asEntity
      streetAndHouseNumber
      cityKompareId
      partnerContactEmail
      oib
      isSamePerson
    }
  }
  product {
    name
    code
    premiumEligibleAgeMin
    premiumEligibleAgeMax
    brand {
      code
      name
      shortName
      logoUrl
    }
    annotations
    fixedCoverages {
      code
      label
      description
    }
  }
}
    ${HealthQuestionnaireOnOfferFragmentDoc}`;
export const AcceptTermsDocument = gql`
    mutation AcceptTerms($id: String!, $input: TermsInput!) {
  acceptTerms(id: $id, input: $input)
}
    `;
export type AcceptTermsMutationFn = Apollo.MutationFunction<AcceptTermsMutation, AcceptTermsMutationVariables>;

/**
 * __useAcceptTermsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsMutation, { data, loading, error }] = useAcceptTermsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptTermsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTermsMutation, AcceptTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTermsMutation, AcceptTermsMutationVariables>(AcceptTermsDocument, options);
      }
export type AcceptTermsMutationHookResult = ReturnType<typeof useAcceptTermsMutation>;
export type AcceptTermsMutationResult = Apollo.MutationResult<AcceptTermsMutation>;
export type AcceptTermsMutationOptions = Apollo.BaseMutationOptions<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const CallMeAdditionalDocument = gql`
    mutation callMeAdditional($input: CallMeInput!) {
  callMe(input: $input)
}
    `;
export type CallMeAdditionalMutationFn = Apollo.MutationFunction<CallMeAdditionalMutation, CallMeAdditionalMutationVariables>;

/**
 * __useCallMeAdditionalMutation__
 *
 * To run a mutation, you first call `useCallMeAdditionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallMeAdditionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callMeAdditionalMutation, { data, loading, error }] = useCallMeAdditionalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCallMeAdditionalMutation(baseOptions?: Apollo.MutationHookOptions<CallMeAdditionalMutation, CallMeAdditionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CallMeAdditionalMutation, CallMeAdditionalMutationVariables>(CallMeAdditionalDocument, options);
      }
export type CallMeAdditionalMutationHookResult = ReturnType<typeof useCallMeAdditionalMutation>;
export type CallMeAdditionalMutationResult = Apollo.MutationResult<CallMeAdditionalMutation>;
export type CallMeAdditionalMutationOptions = Apollo.BaseMutationOptions<CallMeAdditionalMutation, CallMeAdditionalMutationVariables>;
export const CheckoutPaymentErrorsDocument = gql`
    mutation CheckoutPaymentErrors($id: String!, $input: PaymentErrorInput!) {
  checkoutPaymentErrors(id: $id, input: $input)
}
    `;
export type CheckoutPaymentErrorsMutationFn = Apollo.MutationFunction<CheckoutPaymentErrorsMutation, CheckoutPaymentErrorsMutationVariables>;

/**
 * __useCheckoutPaymentErrorsMutation__
 *
 * To run a mutation, you first call `useCheckoutPaymentErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPaymentErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutPaymentErrorsMutation, { data, loading, error }] = useCheckoutPaymentErrorsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckoutPaymentErrorsMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutPaymentErrorsMutation, CheckoutPaymentErrorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutPaymentErrorsMutation, CheckoutPaymentErrorsMutationVariables>(CheckoutPaymentErrorsDocument, options);
      }
export type CheckoutPaymentErrorsMutationHookResult = ReturnType<typeof useCheckoutPaymentErrorsMutation>;
export type CheckoutPaymentErrorsMutationResult = Apollo.MutationResult<CheckoutPaymentErrorsMutation>;
export type CheckoutPaymentErrorsMutationOptions = Apollo.BaseMutationOptions<CheckoutPaymentErrorsMutation, CheckoutPaymentErrorsMutationVariables>;
export const ConfirmRenewalSoDataDocument = gql`
    mutation ConfirmRenewalSoData($id: String!, $input: ConfirmRenewalSoDataInput!) {
  confirmRenewalSoData(id: $id, input: $input)
}
    `;
export type ConfirmRenewalSoDataMutationFn = Apollo.MutationFunction<ConfirmRenewalSoDataMutation, ConfirmRenewalSoDataMutationVariables>;

/**
 * __useConfirmRenewalSoDataMutation__
 *
 * To run a mutation, you first call `useConfirmRenewalSoDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmRenewalSoDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmRenewalSoDataMutation, { data, loading, error }] = useConfirmRenewalSoDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmRenewalSoDataMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmRenewalSoDataMutation, ConfirmRenewalSoDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmRenewalSoDataMutation, ConfirmRenewalSoDataMutationVariables>(ConfirmRenewalSoDataDocument, options);
      }
export type ConfirmRenewalSoDataMutationHookResult = ReturnType<typeof useConfirmRenewalSoDataMutation>;
export type ConfirmRenewalSoDataMutationResult = Apollo.MutationResult<ConfirmRenewalSoDataMutation>;
export type ConfirmRenewalSoDataMutationOptions = Apollo.BaseMutationOptions<ConfirmRenewalSoDataMutation, ConfirmRenewalSoDataMutationVariables>;
export const SetContractorDocument = gql`
    mutation SetContractor($id: String!, $offerId: String!, $input: ContractorInput!) {
  setContractor(id: $id, offerId: $offerId, input: $input)
}
    `;
export type SetContractorMutationFn = Apollo.MutationFunction<SetContractorMutation, SetContractorMutationVariables>;

/**
 * __useSetContractorMutation__
 *
 * To run a mutation, you first call `useSetContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContractorMutation, { data, loading, error }] = useSetContractorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      offerId: // value for 'offerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetContractorMutation(baseOptions?: Apollo.MutationHookOptions<SetContractorMutation, SetContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContractorMutation, SetContractorMutationVariables>(SetContractorDocument, options);
      }
export type SetContractorMutationHookResult = ReturnType<typeof useSetContractorMutation>;
export type SetContractorMutationResult = Apollo.MutationResult<SetContractorMutation>;
export type SetContractorMutationOptions = Apollo.BaseMutationOptions<SetContractorMutation, SetContractorMutationVariables>;
export const CreateHealthOfferDocument = gql`
    mutation CreateHealthOffer($id: String!, $input: CreateOfferInput!) {
  createHealthOffer(id: $id, input: $input)
}
    `;
export type CreateHealthOfferMutationFn = Apollo.MutationFunction<CreateHealthOfferMutation, CreateHealthOfferMutationVariables>;

/**
 * __useCreateHealthOfferMutation__
 *
 * To run a mutation, you first call `useCreateHealthOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHealthOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHealthOfferMutation, { data, loading, error }] = useCreateHealthOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHealthOfferMutation(baseOptions?: Apollo.MutationHookOptions<CreateHealthOfferMutation, CreateHealthOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHealthOfferMutation, CreateHealthOfferMutationVariables>(CreateHealthOfferDocument, options);
      }
export type CreateHealthOfferMutationHookResult = ReturnType<typeof useCreateHealthOfferMutation>;
export type CreateHealthOfferMutationResult = Apollo.MutationResult<CreateHealthOfferMutation>;
export type CreateHealthOfferMutationOptions = Apollo.BaseMutationOptions<CreateHealthOfferMutation, CreateHealthOfferMutationVariables>;
export const CreateSoAdditionalDocument = gql`
    mutation createSoAdditional($input: CreateSoInput!) {
  createSo(input: $input)
}
    `;
export type CreateSoAdditionalMutationFn = Apollo.MutationFunction<CreateSoAdditionalMutation, CreateSoAdditionalMutationVariables>;

/**
 * __useCreateSoAdditionalMutation__
 *
 * To run a mutation, you first call `useCreateSoAdditionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSoAdditionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSoAdditionalMutation, { data, loading, error }] = useCreateSoAdditionalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSoAdditionalMutation(baseOptions?: Apollo.MutationHookOptions<CreateSoAdditionalMutation, CreateSoAdditionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSoAdditionalMutation, CreateSoAdditionalMutationVariables>(CreateSoAdditionalDocument, options);
      }
export type CreateSoAdditionalMutationHookResult = ReturnType<typeof useCreateSoAdditionalMutation>;
export type CreateSoAdditionalMutationResult = Apollo.MutationResult<CreateSoAdditionalMutation>;
export type CreateSoAdditionalMutationOptions = Apollo.BaseMutationOptions<CreateSoAdditionalMutation, CreateSoAdditionalMutationVariables>;
export const PaymentAttemptDocument = gql`
    mutation PaymentAttempt($id: String!) {
  paymentAttempt(id: $id)
}
    `;
export type PaymentAttemptMutationFn = Apollo.MutationFunction<PaymentAttemptMutation, PaymentAttemptMutationVariables>;

/**
 * __usePaymentAttemptMutation__
 *
 * To run a mutation, you first call `usePaymentAttemptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentAttemptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentAttemptMutation, { data, loading, error }] = usePaymentAttemptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentAttemptMutation(baseOptions?: Apollo.MutationHookOptions<PaymentAttemptMutation, PaymentAttemptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentAttemptMutation, PaymentAttemptMutationVariables>(PaymentAttemptDocument, options);
      }
export type PaymentAttemptMutationHookResult = ReturnType<typeof usePaymentAttemptMutation>;
export type PaymentAttemptMutationResult = Apollo.MutationResult<PaymentAttemptMutation>;
export type PaymentAttemptMutationOptions = Apollo.BaseMutationOptions<PaymentAttemptMutation, PaymentAttemptMutationVariables>;
export const SaveAndSubmitHealthQuestionnaireForAdminDocument = gql`
    mutation SaveAndSubmitHealthQuestionnaireForAdmin($id: String!, $input: SaveHealthQuestionnaireAnswersInput!, $adminId: String!) {
  saveAndSubmitHealthQuestionnaireForAdmin(
    id: $id
    input: $input
    adminId: $adminId
  ) {
    rejected
    messages
    needsConfirmation
  }
}
    `;
export type SaveAndSubmitHealthQuestionnaireForAdminMutationFn = Apollo.MutationFunction<SaveAndSubmitHealthQuestionnaireForAdminMutation, SaveAndSubmitHealthQuestionnaireForAdminMutationVariables>;

/**
 * __useSaveAndSubmitHealthQuestionnaireForAdminMutation__
 *
 * To run a mutation, you first call `useSaveAndSubmitHealthQuestionnaireForAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAndSubmitHealthQuestionnaireForAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAndSubmitHealthQuestionnaireForAdminMutation, { data, loading, error }] = useSaveAndSubmitHealthQuestionnaireForAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      adminId: // value for 'adminId'
 *   },
 * });
 */
export function useSaveAndSubmitHealthQuestionnaireForAdminMutation(baseOptions?: Apollo.MutationHookOptions<SaveAndSubmitHealthQuestionnaireForAdminMutation, SaveAndSubmitHealthQuestionnaireForAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAndSubmitHealthQuestionnaireForAdminMutation, SaveAndSubmitHealthQuestionnaireForAdminMutationVariables>(SaveAndSubmitHealthQuestionnaireForAdminDocument, options);
      }
export type SaveAndSubmitHealthQuestionnaireForAdminMutationHookResult = ReturnType<typeof useSaveAndSubmitHealthQuestionnaireForAdminMutation>;
export type SaveAndSubmitHealthQuestionnaireForAdminMutationResult = Apollo.MutationResult<SaveAndSubmitHealthQuestionnaireForAdminMutation>;
export type SaveAndSubmitHealthQuestionnaireForAdminMutationOptions = Apollo.BaseMutationOptions<SaveAndSubmitHealthQuestionnaireForAdminMutation, SaveAndSubmitHealthQuestionnaireForAdminMutationVariables>;
export const SaveHealthQuestionnaireAnswersDocument = gql`
    mutation SaveHealthQuestionnaireAnswers($id: String!, $input: SaveHealthQuestionnaireAnswersInput!) {
  saveHealthQuestionnaireAnswers(id: $id, input: $input)
}
    `;
export type SaveHealthQuestionnaireAnswersMutationFn = Apollo.MutationFunction<SaveHealthQuestionnaireAnswersMutation, SaveHealthQuestionnaireAnswersMutationVariables>;

/**
 * __useSaveHealthQuestionnaireAnswersMutation__
 *
 * To run a mutation, you first call `useSaveHealthQuestionnaireAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHealthQuestionnaireAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHealthQuestionnaireAnswersMutation, { data, loading, error }] = useSaveHealthQuestionnaireAnswersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveHealthQuestionnaireAnswersMutation(baseOptions?: Apollo.MutationHookOptions<SaveHealthQuestionnaireAnswersMutation, SaveHealthQuestionnaireAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveHealthQuestionnaireAnswersMutation, SaveHealthQuestionnaireAnswersMutationVariables>(SaveHealthQuestionnaireAnswersDocument, options);
      }
export type SaveHealthQuestionnaireAnswersMutationHookResult = ReturnType<typeof useSaveHealthQuestionnaireAnswersMutation>;
export type SaveHealthQuestionnaireAnswersMutationResult = Apollo.MutationResult<SaveHealthQuestionnaireAnswersMutation>;
export type SaveHealthQuestionnaireAnswersMutationOptions = Apollo.BaseMutationOptions<SaveHealthQuestionnaireAnswersMutation, SaveHealthQuestionnaireAnswersMutationVariables>;
export const SelectOfferDocument = gql`
    mutation SelectOffer($id: String!) {
  selectOffer(id: $id)
}
    `;
export type SelectOfferMutationFn = Apollo.MutationFunction<SelectOfferMutation, SelectOfferMutationVariables>;

/**
 * __useSelectOfferMutation__
 *
 * To run a mutation, you first call `useSelectOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectOfferMutation, { data, loading, error }] = useSelectOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelectOfferMutation(baseOptions?: Apollo.MutationHookOptions<SelectOfferMutation, SelectOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectOfferMutation, SelectOfferMutationVariables>(SelectOfferDocument, options);
      }
export type SelectOfferMutationHookResult = ReturnType<typeof useSelectOfferMutation>;
export type SelectOfferMutationResult = Apollo.MutationResult<SelectOfferMutation>;
export type SelectOfferMutationOptions = Apollo.BaseMutationOptions<SelectOfferMutation, SelectOfferMutationVariables>;
export const SendGeneralTransferDetailsDocument = gql`
    mutation SendGeneralTransferDetails($id: String!, $input: GeneralTransferDetailsInput!) {
  sendGeneralTransferDetails(id: $id, input: $input)
}
    `;
export type SendGeneralTransferDetailsMutationFn = Apollo.MutationFunction<SendGeneralTransferDetailsMutation, SendGeneralTransferDetailsMutationVariables>;

/**
 * __useSendGeneralTransferDetailsMutation__
 *
 * To run a mutation, you first call `useSendGeneralTransferDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGeneralTransferDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGeneralTransferDetailsMutation, { data, loading, error }] = useSendGeneralTransferDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendGeneralTransferDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SendGeneralTransferDetailsMutation, SendGeneralTransferDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendGeneralTransferDetailsMutation, SendGeneralTransferDetailsMutationVariables>(SendGeneralTransferDetailsDocument, options);
      }
export type SendGeneralTransferDetailsMutationHookResult = ReturnType<typeof useSendGeneralTransferDetailsMutation>;
export type SendGeneralTransferDetailsMutationResult = Apollo.MutationResult<SendGeneralTransferDetailsMutation>;
export type SendGeneralTransferDetailsMutationOptions = Apollo.BaseMutationOptions<SendGeneralTransferDetailsMutation, SendGeneralTransferDetailsMutationVariables>;
export const SendTermsAndConditionsToEmailDocument = gql`
    mutation sendTermsAndConditionsToEmail($offerId: String!) {
  sendTermsAndConditionsToEmail(id: $offerId)
}
    `;
export type SendTermsAndConditionsToEmailMutationFn = Apollo.MutationFunction<SendTermsAndConditionsToEmailMutation, SendTermsAndConditionsToEmailMutationVariables>;

/**
 * __useSendTermsAndConditionsToEmailMutation__
 *
 * To run a mutation, you first call `useSendTermsAndConditionsToEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTermsAndConditionsToEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTermsAndConditionsToEmailMutation, { data, loading, error }] = useSendTermsAndConditionsToEmailMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useSendTermsAndConditionsToEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendTermsAndConditionsToEmailMutation, SendTermsAndConditionsToEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTermsAndConditionsToEmailMutation, SendTermsAndConditionsToEmailMutationVariables>(SendTermsAndConditionsToEmailDocument, options);
      }
export type SendTermsAndConditionsToEmailMutationHookResult = ReturnType<typeof useSendTermsAndConditionsToEmailMutation>;
export type SendTermsAndConditionsToEmailMutationResult = Apollo.MutationResult<SendTermsAndConditionsToEmailMutation>;
export type SendTermsAndConditionsToEmailMutationOptions = Apollo.BaseMutationOptions<SendTermsAndConditionsToEmailMutation, SendTermsAndConditionsToEmailMutationVariables>;
export const SetWsPayResponseDocument = gql`
    mutation SetWsPayResponse($id: String!, $input: WsPayResponseInput!) {
  setWsPayResponse(id: $id, input: $input)
}
    `;
export type SetWsPayResponseMutationFn = Apollo.MutationFunction<SetWsPayResponseMutation, SetWsPayResponseMutationVariables>;

/**
 * __useSetWsPayResponseMutation__
 *
 * To run a mutation, you first call `useSetWsPayResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWsPayResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWsPayResponseMutation, { data, loading, error }] = useSetWsPayResponseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWsPayResponseMutation(baseOptions?: Apollo.MutationHookOptions<SetWsPayResponseMutation, SetWsPayResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWsPayResponseMutation, SetWsPayResponseMutationVariables>(SetWsPayResponseDocument, options);
      }
export type SetWsPayResponseMutationHookResult = ReturnType<typeof useSetWsPayResponseMutation>;
export type SetWsPayResponseMutationResult = Apollo.MutationResult<SetWsPayResponseMutation>;
export type SetWsPayResponseMutationOptions = Apollo.BaseMutationOptions<SetWsPayResponseMutation, SetWsPayResponseMutationVariables>;
export const SubmitHealthQuestionnaireDocument = gql`
    mutation SubmitHealthQuestionnaire($id: String!, $flow: String!) {
  submitHealthQuestionnaire(id: $id, flow: $flow) {
    rejected
    messages
    needsConfirmation
  }
}
    `;
export type SubmitHealthQuestionnaireMutationFn = Apollo.MutationFunction<SubmitHealthQuestionnaireMutation, SubmitHealthQuestionnaireMutationVariables>;

/**
 * __useSubmitHealthQuestionnaireMutation__
 *
 * To run a mutation, you first call `useSubmitHealthQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitHealthQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitHealthQuestionnaireMutation, { data, loading, error }] = useSubmitHealthQuestionnaireMutation({
 *   variables: {
 *      id: // value for 'id'
 *      flow: // value for 'flow'
 *   },
 * });
 */
export function useSubmitHealthQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<SubmitHealthQuestionnaireMutation, SubmitHealthQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitHealthQuestionnaireMutation, SubmitHealthQuestionnaireMutationVariables>(SubmitHealthQuestionnaireDocument, options);
      }
export type SubmitHealthQuestionnaireMutationHookResult = ReturnType<typeof useSubmitHealthQuestionnaireMutation>;
export type SubmitHealthQuestionnaireMutationResult = Apollo.MutationResult<SubmitHealthQuestionnaireMutation>;
export type SubmitHealthQuestionnaireMutationOptions = Apollo.BaseMutationOptions<SubmitHealthQuestionnaireMutation, SubmitHealthQuestionnaireMutationVariables>;
export const GetCalculationsDocument = gql`
    query GetCalculations($input: CalculationRequestInput!) {
  getCalculations(input: $input) {
    code
    label
    logoUrl
    priceWithoutDiscounts
    fixedCoverages {
      code
      label
      tooltip
      description
    }
    coverages {
      code
      label
      tooltip
      price
      description
    }
    prices {
      generalTransfer
      generalTransferWithInstallments
      creditCard
      creditCardWithInstallments
    }
    detailsLink
    premiumEligibleAgeMin
    premiumEligibleAgeMax
  }
}
    `;

/**
 * __useGetCalculationsQuery__
 *
 * To run a query within a React component, call `useGetCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalculationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCalculationsQuery(baseOptions: Apollo.QueryHookOptions<GetCalculationsQuery, GetCalculationsQueryVariables> & ({ variables: GetCalculationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalculationsQuery, GetCalculationsQueryVariables>(GetCalculationsDocument, options);
      }
export function useGetCalculationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalculationsQuery, GetCalculationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalculationsQuery, GetCalculationsQueryVariables>(GetCalculationsDocument, options);
        }
// @ts-ignore
export function useGetCalculationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalculationsQuery, GetCalculationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCalculationsQuery, GetCalculationsQueryVariables>;
export function useGetCalculationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalculationsQuery, GetCalculationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCalculationsQuery | undefined, GetCalculationsQueryVariables>;
export function useGetCalculationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalculationsQuery, GetCalculationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalculationsQuery, GetCalculationsQueryVariables>(GetCalculationsDocument, options);
        }
export type GetCalculationsQueryHookResult = ReturnType<typeof useGetCalculationsQuery>;
export type GetCalculationsLazyQueryHookResult = ReturnType<typeof useGetCalculationsLazyQuery>;
export type GetCalculationsSuspenseQueryHookResult = ReturnType<typeof useGetCalculationsSuspenseQuery>;
export type GetCalculationsQueryResult = Apollo.QueryResult<GetCalculationsQuery, GetCalculationsQueryVariables>;
export const GetCheckoutDataAdditionalDocument = gql`
    query GetCheckoutDataAdditional($id: String!) {
  getOfferPaymentOptions(id: $id) {
    paymentOptions {
      paymentOption
      paymentTypes {
        paymentType
        paymentTypeLabel
        installments {
          installment
          amount
          paymentTypeDiscount
        }
      }
    }
  }
  getOffer(id: $id) {
    _id
    soId
    status
    productTypeSpecific {
      shoppingCartId
      ...HealthQuestionnaireOnOffer
      additional {
        code
        coverages {
          code
          label
          description
        }
        priceChangeModifier {
          amount
          type
          description
        }
        voucherPriceModifier {
          amount
        }
        voucherPriceChangeModifier {
          amount
          type
          description
          code
        }
        gratis {
          additionalSecondOpinion
        }
      }
      calculatedPrices {
        additional {
          baseProductPrice
          total {
            generalTransfer
            creditCard
          }
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
      }
      insuredPerson {
        firstName
        lastName
        birthDate
        partnerContactEmail
        importantNote
        gender
        street
        streetKompareId
        houseNumber
        city
        zipCode
        personType
        asEntity
        streetAndHouseNumber
        cityKompareId
        oib
        karenca
        insuranceNumber
      }
      delivery {
        firstName
        lastName
        gender
        street
        streetKompareId
        isRegularDelivery
        houseNumber
        city
        birthDate
        zipCode
        personType
        asEntity
        streetAndHouseNumber
        cityKompareId
      }
      contractor {
        firstName
        lastName
        gender
        street
        streetKompareId
        houseNumber
        city
        birthDate
        zipCode
        personType
        asEntity
        streetAndHouseNumber
        cityKompareId
        partnerContactEmail
        oib
        isSamePerson
      }
    }
    product {
      name
      code
      brand {
        code
        name
        logoUrl
      }
      annotations
      fixedCoverages {
        code
        label
        description
      }
    }
  }
}
    ${HealthQuestionnaireOnOfferFragmentDoc}`;

/**
 * __useGetCheckoutDataAdditionalQuery__
 *
 * To run a query within a React component, call `useGetCheckoutDataAdditionalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckoutDataAdditionalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckoutDataAdditionalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCheckoutDataAdditionalQuery(baseOptions: Apollo.QueryHookOptions<GetCheckoutDataAdditionalQuery, GetCheckoutDataAdditionalQueryVariables> & ({ variables: GetCheckoutDataAdditionalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckoutDataAdditionalQuery, GetCheckoutDataAdditionalQueryVariables>(GetCheckoutDataAdditionalDocument, options);
      }
export function useGetCheckoutDataAdditionalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckoutDataAdditionalQuery, GetCheckoutDataAdditionalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckoutDataAdditionalQuery, GetCheckoutDataAdditionalQueryVariables>(GetCheckoutDataAdditionalDocument, options);
        }
// @ts-ignore
export function useGetCheckoutDataAdditionalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCheckoutDataAdditionalQuery, GetCheckoutDataAdditionalQueryVariables>): Apollo.UseSuspenseQueryResult<GetCheckoutDataAdditionalQuery, GetCheckoutDataAdditionalQueryVariables>;
export function useGetCheckoutDataAdditionalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCheckoutDataAdditionalQuery, GetCheckoutDataAdditionalQueryVariables>): Apollo.UseSuspenseQueryResult<GetCheckoutDataAdditionalQuery | undefined, GetCheckoutDataAdditionalQueryVariables>;
export function useGetCheckoutDataAdditionalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCheckoutDataAdditionalQuery, GetCheckoutDataAdditionalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCheckoutDataAdditionalQuery, GetCheckoutDataAdditionalQueryVariables>(GetCheckoutDataAdditionalDocument, options);
        }
export type GetCheckoutDataAdditionalQueryHookResult = ReturnType<typeof useGetCheckoutDataAdditionalQuery>;
export type GetCheckoutDataAdditionalLazyQueryHookResult = ReturnType<typeof useGetCheckoutDataAdditionalLazyQuery>;
export type GetCheckoutDataAdditionalSuspenseQueryHookResult = ReturnType<typeof useGetCheckoutDataAdditionalSuspenseQuery>;
export type GetCheckoutDataAdditionalQueryResult = Apollo.QueryResult<GetCheckoutDataAdditionalQuery, GetCheckoutDataAdditionalQueryVariables>;
export const GetTermsAndConditionsByIdDocument = gql`
    query GetTermsAndConditionsById($fileId: String!) {
  getTermsAndConditionsById(id: $fileId) {
    fileName
    contentType
    downloadUrl
  }
}
    `;

/**
 * __useGetTermsAndConditionsByIdQuery__
 *
 * To run a query within a React component, call `useGetTermsAndConditionsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsAndConditionsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsAndConditionsByIdQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetTermsAndConditionsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables> & ({ variables: GetTermsAndConditionsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>(GetTermsAndConditionsByIdDocument, options);
      }
export function useGetTermsAndConditionsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>(GetTermsAndConditionsByIdDocument, options);
        }
// @ts-ignore
export function useGetTermsAndConditionsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>;
export function useGetTermsAndConditionsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetTermsAndConditionsByIdQuery | undefined, GetTermsAndConditionsByIdQueryVariables>;
export function useGetTermsAndConditionsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>(GetTermsAndConditionsByIdDocument, options);
        }
export type GetTermsAndConditionsByIdQueryHookResult = ReturnType<typeof useGetTermsAndConditionsByIdQuery>;
export type GetTermsAndConditionsByIdLazyQueryHookResult = ReturnType<typeof useGetTermsAndConditionsByIdLazyQuery>;
export type GetTermsAndConditionsByIdSuspenseQueryHookResult = ReturnType<typeof useGetTermsAndConditionsByIdSuspenseQuery>;
export type GetTermsAndConditionsByIdQueryResult = Apollo.QueryResult<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>;
export const GetGeneralTransferPaymentDetailsDocument = gql`
    query GetGeneralTransferPaymentDetails($id: String!, $input: GeneralTransferDetailsInput!) {
  getGeneralTransferPaymentDetails(id: $id, input: $input) {
    price
    customerFirstName
    customerLastName
    customerAddress
    customerCity
    customerZipCode
    customerCountry
    customerPhone
    customerEmail
    customerOib
    recipientName
    recipientAddress
    recipientCity
    recipientZipCode
    recipientAccountNumber
    referenceNumber
    referenceNumberType
    referencePrefix
    referenceSuffix
    model
    description
    numberOfInstallments
  }
}
    `;

/**
 * __useGetGeneralTransferPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useGetGeneralTransferPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralTransferPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralTransferPaymentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGeneralTransferPaymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables> & ({ variables: GetGeneralTransferPaymentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>(GetGeneralTransferPaymentDetailsDocument, options);
      }
export function useGetGeneralTransferPaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>(GetGeneralTransferPaymentDetailsDocument, options);
        }
// @ts-ignore
export function useGetGeneralTransferPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>;
export function useGetGeneralTransferPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneralTransferPaymentDetailsQuery | undefined, GetGeneralTransferPaymentDetailsQueryVariables>;
export function useGetGeneralTransferPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>(GetGeneralTransferPaymentDetailsDocument, options);
        }
export type GetGeneralTransferPaymentDetailsQueryHookResult = ReturnType<typeof useGetGeneralTransferPaymentDetailsQuery>;
export type GetGeneralTransferPaymentDetailsLazyQueryHookResult = ReturnType<typeof useGetGeneralTransferPaymentDetailsLazyQuery>;
export type GetGeneralTransferPaymentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetGeneralTransferPaymentDetailsSuspenseQuery>;
export type GetGeneralTransferPaymentDetailsQueryResult = Apollo.QueryResult<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>;
export const HealthQuestionnaireQuestionsDocument = gql`
    query HealthQuestionnaireQuestions($brandCode: String!, $productCode: String!, $dontExclude: Boolean) {
  healthQuestionnaireQuestions(
    brandCode: $brandCode
    productCode: $productCode
    dontExclude: $dontExclude
  ) {
    code
    type
    required
    title
    description
    extraInfo
    selectionMode
    options {
      value
      label
    }
    columns {
      value
      label
    }
    rows {
      code
      label
    }
    followUp {
      code
      type
      required
      visibility {
        when
        parentQuestionCode
        operator
        value
        countWhere {
          answer
        }
      }
      requireWhen {
        when
        parentQuestionCode
        operator
        value
        countWhere {
          answer
        }
      }
      fields {
        code
        label
        required
        inputType
        options {
          label
          value
        }
      }
    }
    questions {
      code
      type
      required
      title
      description
      extraInfo
      options {
        value
        label
      }
      followUp {
        code
        type
        required
        visibility {
          when
          parentQuestionCode
          operator
          value
          countWhere {
            answer
          }
        }
        requireWhen {
          when
          parentQuestionCode
          operator
          value
          countWhere {
            answer
          }
        }
        fields {
          code
          label
          required
          inputType
          options {
            label
            value
          }
        }
      }
      questions {
        code
        type
        required
        title
        description
        extraInfo
        options {
          value
          label
        }
      }
    }
  }
}
    `;

/**
 * __useHealthQuestionnaireQuestionsQuery__
 *
 * To run a query within a React component, call `useHealthQuestionnaireQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthQuestionnaireQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthQuestionnaireQuestionsQuery({
 *   variables: {
 *      brandCode: // value for 'brandCode'
 *      productCode: // value for 'productCode'
 *      dontExclude: // value for 'dontExclude'
 *   },
 * });
 */
export function useHealthQuestionnaireQuestionsQuery(baseOptions: Apollo.QueryHookOptions<HealthQuestionnaireQuestionsQuery, HealthQuestionnaireQuestionsQueryVariables> & ({ variables: HealthQuestionnaireQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HealthQuestionnaireQuestionsQuery, HealthQuestionnaireQuestionsQueryVariables>(HealthQuestionnaireQuestionsDocument, options);
      }
export function useHealthQuestionnaireQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HealthQuestionnaireQuestionsQuery, HealthQuestionnaireQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HealthQuestionnaireQuestionsQuery, HealthQuestionnaireQuestionsQueryVariables>(HealthQuestionnaireQuestionsDocument, options);
        }
// @ts-ignore
export function useHealthQuestionnaireQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HealthQuestionnaireQuestionsQuery, HealthQuestionnaireQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<HealthQuestionnaireQuestionsQuery, HealthQuestionnaireQuestionsQueryVariables>;
export function useHealthQuestionnaireQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HealthQuestionnaireQuestionsQuery, HealthQuestionnaireQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<HealthQuestionnaireQuestionsQuery | undefined, HealthQuestionnaireQuestionsQueryVariables>;
export function useHealthQuestionnaireQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HealthQuestionnaireQuestionsQuery, HealthQuestionnaireQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HealthQuestionnaireQuestionsQuery, HealthQuestionnaireQuestionsQueryVariables>(HealthQuestionnaireQuestionsDocument, options);
        }
export type HealthQuestionnaireQuestionsQueryHookResult = ReturnType<typeof useHealthQuestionnaireQuestionsQuery>;
export type HealthQuestionnaireQuestionsLazyQueryHookResult = ReturnType<typeof useHealthQuestionnaireQuestionsLazyQuery>;
export type HealthQuestionnaireQuestionsSuspenseQueryHookResult = ReturnType<typeof useHealthQuestionnaireQuestionsSuspenseQuery>;
export type HealthQuestionnaireQuestionsQueryResult = Apollo.QueryResult<HealthQuestionnaireQuestionsQuery, HealthQuestionnaireQuestionsQueryVariables>;
export const GetOfferDocument = gql`
    query GetOffer($id: String!) {
  getOffer(id: $id) {
    ...GetOfferDtoData
  }
}
    ${GetOfferDtoDataFragmentDoc}`;

/**
 * __useGetOfferQuery__
 *
 * To run a query within a React component, call `useGetOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferQuery(baseOptions: Apollo.QueryHookOptions<GetOfferQuery, GetOfferQueryVariables> & ({ variables: GetOfferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
      }
export function useGetOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
        }
// @ts-ignore
export function useGetOfferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferQuery, GetOfferQueryVariables>;
export function useGetOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferQuery | undefined, GetOfferQueryVariables>;
export function useGetOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
        }
export type GetOfferQueryHookResult = ReturnType<typeof useGetOfferQuery>;
export type GetOfferLazyQueryHookResult = ReturnType<typeof useGetOfferLazyQuery>;
export type GetOfferSuspenseQueryHookResult = ReturnType<typeof useGetOfferSuspenseQuery>;
export type GetOfferQueryResult = Apollo.QueryResult<GetOfferQuery, GetOfferQueryVariables>;
export const GetOfferForAgentDocument = gql`
    query GetOfferForAgent($id: String!, $adminId: String!) {
  getOfferForAgent(id: $id, adminId: $adminId) {
    ...GetOfferDtoData
  }
}
    ${GetOfferDtoDataFragmentDoc}`;

/**
 * __useGetOfferForAgentQuery__
 *
 * To run a query within a React component, call `useGetOfferForAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferForAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferForAgentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      adminId: // value for 'adminId'
 *   },
 * });
 */
export function useGetOfferForAgentQuery(baseOptions: Apollo.QueryHookOptions<GetOfferForAgentQuery, GetOfferForAgentQueryVariables> & ({ variables: GetOfferForAgentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferForAgentQuery, GetOfferForAgentQueryVariables>(GetOfferForAgentDocument, options);
      }
export function useGetOfferForAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferForAgentQuery, GetOfferForAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferForAgentQuery, GetOfferForAgentQueryVariables>(GetOfferForAgentDocument, options);
        }
// @ts-ignore
export function useGetOfferForAgentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferForAgentQuery, GetOfferForAgentQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferForAgentQuery, GetOfferForAgentQueryVariables>;
export function useGetOfferForAgentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferForAgentQuery, GetOfferForAgentQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferForAgentQuery | undefined, GetOfferForAgentQueryVariables>;
export function useGetOfferForAgentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferForAgentQuery, GetOfferForAgentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferForAgentQuery, GetOfferForAgentQueryVariables>(GetOfferForAgentDocument, options);
        }
export type GetOfferForAgentQueryHookResult = ReturnType<typeof useGetOfferForAgentQuery>;
export type GetOfferForAgentLazyQueryHookResult = ReturnType<typeof useGetOfferForAgentLazyQuery>;
export type GetOfferForAgentSuspenseQueryHookResult = ReturnType<typeof useGetOfferForAgentSuspenseQuery>;
export type GetOfferForAgentQueryResult = Apollo.QueryResult<GetOfferForAgentQuery, GetOfferForAgentQueryVariables>;
export const GetOfferForPrintDocument = gql`
    query GetOfferForPrint($id: String!) {
  getOfferForPrint(id: $id) {
    ...GetOfferDtoData
  }
}
    ${GetOfferDtoDataFragmentDoc}`;

/**
 * __useGetOfferForPrintQuery__
 *
 * To run a query within a React component, call `useGetOfferForPrintQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferForPrintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferForPrintQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferForPrintQuery(baseOptions: Apollo.QueryHookOptions<GetOfferForPrintQuery, GetOfferForPrintQueryVariables> & ({ variables: GetOfferForPrintQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferForPrintQuery, GetOfferForPrintQueryVariables>(GetOfferForPrintDocument, options);
      }
export function useGetOfferForPrintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferForPrintQuery, GetOfferForPrintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferForPrintQuery, GetOfferForPrintQueryVariables>(GetOfferForPrintDocument, options);
        }
// @ts-ignore
export function useGetOfferForPrintSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferForPrintQuery, GetOfferForPrintQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferForPrintQuery, GetOfferForPrintQueryVariables>;
export function useGetOfferForPrintSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferForPrintQuery, GetOfferForPrintQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferForPrintQuery | undefined, GetOfferForPrintQueryVariables>;
export function useGetOfferForPrintSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferForPrintQuery, GetOfferForPrintQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferForPrintQuery, GetOfferForPrintQueryVariables>(GetOfferForPrintDocument, options);
        }
export type GetOfferForPrintQueryHookResult = ReturnType<typeof useGetOfferForPrintQuery>;
export type GetOfferForPrintLazyQueryHookResult = ReturnType<typeof useGetOfferForPrintLazyQuery>;
export type GetOfferForPrintSuspenseQueryHookResult = ReturnType<typeof useGetOfferForPrintSuspenseQuery>;
export type GetOfferForPrintQueryResult = Apollo.QueryResult<GetOfferForPrintQuery, GetOfferForPrintQueryVariables>;
export const GetOffersBySoIdDocument = gql`
    query GetOffersBySoId($id: String!) {
  getOffersBySoId(id: $id) {
    _id
    status
    productTypeSpecific {
      shoppingCartId
      ...HealthQuestionnaireOnOffer
      additional {
        code
        coverages {
          code
          label
          description
        }
        priceChangeModifier {
          amount
          type
          description
        }
        voucherPriceModifier {
          amount
        }
        voucherPriceChangeModifier {
          amount
          type
          description
          code
        }
        gratis {
          additionalSecondOpinion
        }
      }
      calculatedPrices {
        additional {
          baseProductPrice
          total {
            generalTransfer
            creditCard
          }
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
      }
      insuredPerson {
        firstName
        lastName
        birthDate
        partnerContactEmail
        importantNote
        gender
      }
    }
    product {
      name
      code
      premiumEligibleAgeMin
      premiumEligibleAgeMax
      brand {
        code
        name
        logoUrl
      }
      annotations
      fixedCoverages {
        code
        label
        description
      }
    }
  }
}
    ${HealthQuestionnaireOnOfferFragmentDoc}`;

/**
 * __useGetOffersBySoIdQuery__
 *
 * To run a query within a React component, call `useGetOffersBySoIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOffersBySoIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOffersBySoIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOffersBySoIdQuery(baseOptions: Apollo.QueryHookOptions<GetOffersBySoIdQuery, GetOffersBySoIdQueryVariables> & ({ variables: GetOffersBySoIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOffersBySoIdQuery, GetOffersBySoIdQueryVariables>(GetOffersBySoIdDocument, options);
      }
export function useGetOffersBySoIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOffersBySoIdQuery, GetOffersBySoIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOffersBySoIdQuery, GetOffersBySoIdQueryVariables>(GetOffersBySoIdDocument, options);
        }
// @ts-ignore
export function useGetOffersBySoIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOffersBySoIdQuery, GetOffersBySoIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetOffersBySoIdQuery, GetOffersBySoIdQueryVariables>;
export function useGetOffersBySoIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOffersBySoIdQuery, GetOffersBySoIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetOffersBySoIdQuery | undefined, GetOffersBySoIdQueryVariables>;
export function useGetOffersBySoIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOffersBySoIdQuery, GetOffersBySoIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOffersBySoIdQuery, GetOffersBySoIdQueryVariables>(GetOffersBySoIdDocument, options);
        }
export type GetOffersBySoIdQueryHookResult = ReturnType<typeof useGetOffersBySoIdQuery>;
export type GetOffersBySoIdLazyQueryHookResult = ReturnType<typeof useGetOffersBySoIdLazyQuery>;
export type GetOffersBySoIdSuspenseQueryHookResult = ReturnType<typeof useGetOffersBySoIdSuspenseQuery>;
export type GetOffersBySoIdQueryResult = Apollo.QueryResult<GetOffersBySoIdQuery, GetOffersBySoIdQueryVariables>;
export const GetSoDocument = gql`
    query GetSo($id: String!) {
  getSo(id: $id) {
    _id
    soNumber
    status
    source
    email
    phoneNumber
    fullName
    firstName
    lastName
    productTypeId {
      _id
      code
      name
    }
    funnel {
      latestStep
      steps {
        code
        openedAt
      }
    }
    productTypeSpecific {
      additionalInsuranceInfo {
        physicalExamination
        specialistExaminations
        diagnostic
        laboratoryExaminations
        mrCt
        physicalTherapy
        smallOperatingCycles
        reasonOfPurchase
        perMonthPayment
      }
      insuredPerson {
        firstName
        lastName
        birthDate
        city
        cityKompareId
        zipCode
        oib
        street
        streetKompareId
        streetAndHouseNumber
        houseNumber
        gender
        personType
        partnerContactEmail
        oldPolicyNumber
        newPolicyStartDate
      }
      renewalOf {
        productTypeCode
        productCode
        newPolicyStartDate
        oldPolicy {
          brandCode
          brandName
          endDate
        }
      }
    }
    admin {
      name
      email
      avatar
    }
  }
}
    `;

/**
 * __useGetSoQuery__
 *
 * To run a query within a React component, call `useGetSoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSoQuery(baseOptions: Apollo.QueryHookOptions<GetSoQuery, GetSoQueryVariables> & ({ variables: GetSoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSoQuery, GetSoQueryVariables>(GetSoDocument, options);
      }
export function useGetSoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSoQuery, GetSoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSoQuery, GetSoQueryVariables>(GetSoDocument, options);
        }
// @ts-ignore
export function useGetSoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSoQuery, GetSoQueryVariables>): Apollo.UseSuspenseQueryResult<GetSoQuery, GetSoQueryVariables>;
export function useGetSoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSoQuery, GetSoQueryVariables>): Apollo.UseSuspenseQueryResult<GetSoQuery | undefined, GetSoQueryVariables>;
export function useGetSoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSoQuery, GetSoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSoQuery, GetSoQueryVariables>(GetSoDocument, options);
        }
export type GetSoQueryHookResult = ReturnType<typeof useGetSoQuery>;
export type GetSoLazyQueryHookResult = ReturnType<typeof useGetSoLazyQuery>;
export type GetSoSuspenseQueryHookResult = ReturnType<typeof useGetSoSuspenseQuery>;
export type GetSoQueryResult = Apollo.QueryResult<GetSoQuery, GetSoQueryVariables>;
export const GetTermsAndConditionsFromFilesDocument = gql`
    query getTermsAndConditionsFromFiles($id: String!) {
  getTermsAndConditionsFromFiles(id: $id) {
    brandName
    brandCode
    logoUrl
    documents {
      fileId
      fileName
    }
  }
}
    `;

/**
 * __useGetTermsAndConditionsFromFilesQuery__
 *
 * To run a query within a React component, call `useGetTermsAndConditionsFromFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsAndConditionsFromFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsAndConditionsFromFilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTermsAndConditionsFromFilesQuery(baseOptions: Apollo.QueryHookOptions<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables> & ({ variables: GetTermsAndConditionsFromFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>(GetTermsAndConditionsFromFilesDocument, options);
      }
export function useGetTermsAndConditionsFromFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>(GetTermsAndConditionsFromFilesDocument, options);
        }
// @ts-ignore
export function useGetTermsAndConditionsFromFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>;
export function useGetTermsAndConditionsFromFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTermsAndConditionsFromFilesQuery | undefined, GetTermsAndConditionsFromFilesQueryVariables>;
export function useGetTermsAndConditionsFromFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>(GetTermsAndConditionsFromFilesDocument, options);
        }
export type GetTermsAndConditionsFromFilesQueryHookResult = ReturnType<typeof useGetTermsAndConditionsFromFilesQuery>;
export type GetTermsAndConditionsFromFilesLazyQueryHookResult = ReturnType<typeof useGetTermsAndConditionsFromFilesLazyQuery>;
export type GetTermsAndConditionsFromFilesSuspenseQueryHookResult = ReturnType<typeof useGetTermsAndConditionsFromFilesSuspenseQuery>;
export type GetTermsAndConditionsFromFilesQueryResult = Apollo.QueryResult<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>;
export const GetTermsAndConditionsByOfferDocument = gql`
    query GetTermsAndConditionsByOffer($id: String!) {
  getTermsAndConditions(id: $id) {
    brandName
    brandCode
    logoUrl
    documents {
      fileId
      fileName
    }
  }
  getTermsOffer(id: $id) {
    product {
      name
      code
      brand {
        code
        name
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetTermsAndConditionsByOfferQuery__
 *
 * To run a query within a React component, call `useGetTermsAndConditionsByOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsAndConditionsByOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsAndConditionsByOfferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTermsAndConditionsByOfferQuery(baseOptions: Apollo.QueryHookOptions<GetTermsAndConditionsByOfferQuery, GetTermsAndConditionsByOfferQueryVariables> & ({ variables: GetTermsAndConditionsByOfferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsAndConditionsByOfferQuery, GetTermsAndConditionsByOfferQueryVariables>(GetTermsAndConditionsByOfferDocument, options);
      }
export function useGetTermsAndConditionsByOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsAndConditionsByOfferQuery, GetTermsAndConditionsByOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsAndConditionsByOfferQuery, GetTermsAndConditionsByOfferQueryVariables>(GetTermsAndConditionsByOfferDocument, options);
        }
// @ts-ignore
export function useGetTermsAndConditionsByOfferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTermsAndConditionsByOfferQuery, GetTermsAndConditionsByOfferQueryVariables>): Apollo.UseSuspenseQueryResult<GetTermsAndConditionsByOfferQuery, GetTermsAndConditionsByOfferQueryVariables>;
export function useGetTermsAndConditionsByOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTermsAndConditionsByOfferQuery, GetTermsAndConditionsByOfferQueryVariables>): Apollo.UseSuspenseQueryResult<GetTermsAndConditionsByOfferQuery | undefined, GetTermsAndConditionsByOfferQueryVariables>;
export function useGetTermsAndConditionsByOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTermsAndConditionsByOfferQuery, GetTermsAndConditionsByOfferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTermsAndConditionsByOfferQuery, GetTermsAndConditionsByOfferQueryVariables>(GetTermsAndConditionsByOfferDocument, options);
        }
export type GetTermsAndConditionsByOfferQueryHookResult = ReturnType<typeof useGetTermsAndConditionsByOfferQuery>;
export type GetTermsAndConditionsByOfferLazyQueryHookResult = ReturnType<typeof useGetTermsAndConditionsByOfferLazyQuery>;
export type GetTermsAndConditionsByOfferSuspenseQueryHookResult = ReturnType<typeof useGetTermsAndConditionsByOfferSuspenseQuery>;
export type GetTermsAndConditionsByOfferQueryResult = Apollo.QueryResult<GetTermsAndConditionsByOfferQuery, GetTermsAndConditionsByOfferQueryVariables>;
export const GetWsPayPaymentDataDocument = gql`
    query GetWSPayPaymentData($id: String!, $input: GetWspayPaymentDataInput!) {
  getWSPayPaymentData(id: $id, input: $input) {
    ShopID
    ShoppingCartID
    TotalAmount
    Signature
    ReturnURL
    CancelURL
    ReturnErrorURL
    PaymentPlan
    CustomerFirstName
    CustomerLastName
    CustomerAddress
    CustomerCity
    CustomerZIP
    CustomerCountry
    CustomerPhone
    CustomerEmail
    PaymentMethod
    Iframe
    IframeResponseTarget
    Version
  }
}
    `;

/**
 * __useGetWsPayPaymentDataQuery__
 *
 * To run a query within a React component, call `useGetWsPayPaymentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWsPayPaymentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWsPayPaymentDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWsPayPaymentDataQuery(baseOptions: Apollo.QueryHookOptions<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables> & ({ variables: GetWsPayPaymentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>(GetWsPayPaymentDataDocument, options);
      }
export function useGetWsPayPaymentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>(GetWsPayPaymentDataDocument, options);
        }
// @ts-ignore
export function useGetWsPayPaymentDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>;
export function useGetWsPayPaymentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetWsPayPaymentDataQuery | undefined, GetWsPayPaymentDataQueryVariables>;
export function useGetWsPayPaymentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>(GetWsPayPaymentDataDocument, options);
        }
export type GetWsPayPaymentDataQueryHookResult = ReturnType<typeof useGetWsPayPaymentDataQuery>;
export type GetWsPayPaymentDataLazyQueryHookResult = ReturnType<typeof useGetWsPayPaymentDataLazyQuery>;
export type GetWsPayPaymentDataSuspenseQueryHookResult = ReturnType<typeof useGetWsPayPaymentDataSuspenseQuery>;
export type GetWsPayPaymentDataQueryResult = Apollo.QueryResult<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>;
export const OfferChangedDocument = gql`
    subscription OfferChanged($id: String!) {
  offerChanged(id: $id) {
    ...GetOfferDtoData
  }
}
    ${GetOfferDtoDataFragmentDoc}`;

/**
 * __useOfferChangedSubscription__
 *
 * To run a query within a React component, call `useOfferChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOfferChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferChangedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOfferChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OfferChangedSubscription, OfferChangedSubscriptionVariables> & ({ variables: OfferChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OfferChangedSubscription, OfferChangedSubscriptionVariables>(OfferChangedDocument, options);
      }
export type OfferChangedSubscriptionHookResult = ReturnType<typeof useOfferChangedSubscription>;
export type OfferChangedSubscriptionResult = Apollo.SubscriptionResult<OfferChangedSubscription>;
export const OffersChangedDocument = gql`
    subscription OffersChanged($soId: String!) {
  offersChanged(soId: $soId)
}
    `;

/**
 * __useOffersChangedSubscription__
 *
 * To run a query within a React component, call `useOffersChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOffersChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersChangedSubscription({
 *   variables: {
 *      soId: // value for 'soId'
 *   },
 * });
 */
export function useOffersChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OffersChangedSubscription, OffersChangedSubscriptionVariables> & ({ variables: OffersChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OffersChangedSubscription, OffersChangedSubscriptionVariables>(OffersChangedDocument, options);
      }
export type OffersChangedSubscriptionHookResult = ReturnType<typeof useOffersChangedSubscription>;
export type OffersChangedSubscriptionResult = Apollo.SubscriptionResult<OffersChangedSubscription>;